import React, { Suspense, useEffect, useState } from "react";
import $, { event } from "jquery";
// import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import {
  apiCalling,
  awsAPIUrlcommon,
  validateEmail,
  formatDatePickerToddMMyyyy,
} from "../../apiService";
import IcoAdd from "../../image/icons/plus.png";
import IcoCancel from "../../image/icons/close-sm.png";
import upload from "../../image/media/upload.png";
import HospitalAutoComplete from "../siteSettings/HospitalAutoComplete";
import DoctorAutoComplete from "../siteSettings/DoctorAutoComplete";
import AWS from "aws-sdk";
import { Link } from "react-router-dom";
import { addDays } from "date-fns";
import Close from "../../image/icons/close-mark.png";
import stringreplacenpm from "stringreplacenpm";
import AddMetaDataPopup from "../siteSettings/addMetaDataPopup";
var s3;
let fullFilePath;
var imageFile;
const navigation = [
  { pageName: "Dashboard", url: "/admin/dashboard" },
  { pageName: "Admin Management", url: "/admin/dashboardAdmin" },
  { pageName: "Site Settings", url: "/adminManagement/SiteSettings" },
  {
    pageName: "Add/Edit Site",
    url: "/adminManagement/SiteSettings-AddEdit",
    current: true,
  },
];
const axios = require("axios");
const today = formatDatePickerToddMMyyyy(new Date());
const twoYearAfterToday = formatDatePickerToddMMyyyy(addDays(new Date(), 730));

export default function SiteSettingsAddEditUpdate({
  changeMode,
  siteIdProp,
  imagePathData,
  groupHospitalAdminIdProp,
}) {
  //!state variables
  const [siteId, setsiteId] = useState(siteIdProp === 0 ? "" : siteIdProp);
  const [groupHospitalAdminId, setGroupHospitalAdminId] = useState(
    groupHospitalAdminIdProp
  );
  const [contactNo, setcontactNo] = useState("");
  const [googleSiteAnalytics, setgoogleSiteAnalytics] = useState(
    `<script type="text/javascript">(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga'); ga('create', 'UA-24459463-1', 'PurpleHealth.com'); ga('send', 'pageview'); </script>`
  );
  const [siteEmailId, setsiteEmailId] = useState("");
  const [dashboardHtml, setdashboardHtml] = useState("");
  const [emailHost, setemailHost] = useState("smtp.purplehealth.com");
  const [emailPassword, setemailPassword] = useState("DoctorVillage1");
  const [showExpertDoctorsList, setshowExpertDoctorsList] = useState(false);
  const [showSpecializationList, setshowSpecializationList] = useState(false);
  const [emailPort, setemailPort] = useState("587");
  const [emailUserId, setemailUserId] = useState("support@purplehealth.com");
  const [favIcon, setfavIcon] = useState("");
  const [innerHtml, setinnerHtml] =
    useState(`<!DOCTYPE html><html className="no-js"> <head> <meta charset="utf-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <title></title> <link rel="shortcut icon" href="images/fav.ico" type="image/ico"/> <meta name="description" content=""> <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0"> <link rel="stylesheet" href="css/vendor/font-awesome.min.css"> <script src="js/vendor/jquery-1.11.1.min.js"></script> <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBkbwXs7aQKmVppkhraLWn3GynM0VXoPXE&"></script> <style>@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Thin.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Thin.woff') format('woff'); font-weight: 100; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Regular.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Regular.woff') format('woff'); font-weight: normal; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Bold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Bold.woff') format('woff'); font-weight: bold; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Regular.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Regular.woff') format('woff'); font-weight: normal; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-SemiBoldItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-SemiBoldItalic.woff') format('woff'); font-weight: 600; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraLightItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraLightItalic.woff') format('woff'); font-weight: 200; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraBoldItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraBoldItalic.woff') format('woff'); font-weight: 800; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-BlackItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-BlackItalic.woff') format('woff'); font-weight: 900; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Thin.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Thin.woff') format('woff'); font-weight: 100; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-MediumItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-MediumItalic.woff') format('woff'); font-weight: 500; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Medium.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Medium.woff') format('woff'); font-weight: 500; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraBold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraBold.woff') format('woff'); font-weight: 800; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-SemiBold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-SemiBold.woff') format('woff'); font-weight: 600; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Italic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Italic.woff') format('woff'); font-weight: normal; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ThinItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ThinItalic.woff') format('woff'); font-weight: 100; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraLight.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-ExtraLight.woff') format('woff'); font-weight: 200; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-LightItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-LightItalic.woff') format('woff'); font-weight: 300; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-BoldItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-BoldItalic.woff') format('woff'); font-weight: bold; font-style: italic;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Light.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Light.woff') format('woff'); font-weight: 300; font-style: normal;}@font-face{font-family: 'Montserrat'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Bold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/Montserrat-Bold.woff') format('woff'); font-weight: bold; font-style: normal;}@font-face{font-family: 'Archivo Narrow'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-BoldItalic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-BoldItalic.woff') format('woff'); font-weight: bold; font-style: italic;}@font-face{font-family: 'Archivo Narrow'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Italic.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Italic.woff') format('woff'); font-weight: normal; font-style: italic;}@font-face{font-family: 'Archivo Narrow'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Bold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Bold.woff') format('woff'); font-weight: bold; font-style: normal;}@font-face{font-family: 'Archivo Narrow'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Regular.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/ArchivoNarrow-Regular.woff') format('woff'); font-weight: normal; font-style: normal;}@font-face{font-family: 'Open Sans'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/OpenSans-Semibold.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/OpenSans-Semibold.woff') format('woff'); font-weight: 600; font-style: normal;}@font-face{font-family: 'Open Sans'; src: url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/OpenSans-Light.woff2') format('woff2'), url('https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/fonts/OpenSans-Light.woff') format('woff'); font-weight: 300; font-style: normal;}.iconTab{width: 30%; margin: 0 6px 45px; text-align: center; display: inline-block; vertical-align: top; background: #fff; padding: 10px; -webkit-box-shadow: 0px 0px 20px 0px rgba(179, 174, 174, 0.49); -moz-box-shadow: 0px 0px 20px 0px rgba(179, 174, 174, 0.49); box-shadow: 0px 0px 20px 0px rgba(179, 174, 174, 0.49); min-height:430px; position: relative;}
    .iconTabLong{min-height: 500px;}section{background: #f5f4f9;}.iconTab img{width: 110px; border-radius: 50%; border: 1px solid #d0cfcf;}.iconTab p{margin: 0 auto 15px; text-align: left;}.owl-theme .owl-controls .owl-page span{background: #000000;}.owl-buttons{display: none;}.iconSection{margin: 30px 0 0;}.previous{background-color: #f1f1f1; color: black;}.next{background-color: #4CAF50; color: white;}.contentHead{font-size: 44px; font-weight: 300; padding: 10px 0 50px; color: #191919; text-align: center;}.icon img{padding: 12px; width: 43px; border-radius: 0; border: 0; background: #8200ff;}.icon{position: absolute; top: -15px; left: 14px;}.round{border-radius: 50%;}@media (max-width: 1200px){.iconTab{margin: 0 6px 45px;}.iconTab p{font-size: 13px;}.iconTab{min-height: 377px;}.iconTabLong{min-height: 521px;}}@media (max-width: 1024px){}@media (max-width: 992px){.iconTab{margin: 0 10px 45px; width: 46%;}.iconTab{min-height: 521px;}}@media (max-width: 768px){}@media (max-width: 767px){.iconTab p{width: 100%;}.iconTab{width: 100%; height: auto; min-height:auto;}.icon img{width: 15px;}.contentHead{font-size: 31px;}}p{margin:0; padding:0;}h1, h2, h3,h4, h5, h6{margin:15px 0; padding:0;}body{font-family: 'Montserrat';}.coverWrap{width: 100%; clear: both; overflow: hidden;}.First{width: 100%; clear: both; overflow: hidden; background: #fff; padding: 40px 0 60px;}.headerText{text-align: center;}.headerText h2{font-size: 42px; font-weight: 700; margin: 23px 0;}.headerText h2 span{font-weight: 400; letter-spacing: -1px; font-size: 31px; color: #000;}.firstLeft{width: 50%; display: inline-block; vertical-align: top; padding: 65px 0 20px;}.firstLeft ul li{color: #000000; font-size: 27px; margin:8px 0; position:relative; font-family: 'Open Sans'; font-weight: 500; line-height: 53px;}.firstImg{width: 40%; display: inline-block; vertical-align: top; padding: 10px 10px; text-align: center;}.firstImg img{width: 75%;}.sixth .firstImg img{width: 100%; padding-top: 196px;}.buttonDiv{width: 100%; text-align: center; padding: 30px 0 20px; clear: both;}.buttonDiv button{background: #2d90e1; color: #fff; border: 0; font-family: 'Open Sans'; padding: 10px 14px; font-size: 26px; font-weight: 600; border-radius: 4px; letter-spacing: 1px;}/*secnd*/.second{width: 100%; clear: both; overflow: hidden; background: #f5f4f9; padding: 40px 0 20px;}.secondRight{width: 50%; display: inline-block; vertical-align: top; padding: 0px 0 20px 45px;}.secondRight .headerText{text-align: left;}.secondRight .headerText h2{text-align: left; line-height: 60px; font-size: 37px; font-weight: 600;}.sixth .secondRight .headerText h2{text-align: left; line-height: 60px; font-size: 33px;}.buttonDiv a{text-decoration: none; color: #ffff;}.containerNew{width: 80%; margin: 0 auto; position: relative;}.second .firstLeft ul li{font-size: 27px; position: relative;}/*third*/.third .firstLeft{width: 44%; padding: 0px 0 20px;}.third{width: 100%; clear: both; overflow: hidden; padding: 20px 0;}.third .secondRight{width: 61%;}.third .firstImg{width: 25%; margin: 72px 0;}.third .secondRight .headerText h2{line-height: 42px;}.third .firstLeft ul li{font-size: 27px; position: relative;}/*fourth*/.fourth{width: 100%; clear: both; overflow: hidden; padding: 15px 0; background: #f5f4f9;}.fourth .firstImg{width: 30%;}.fourth .secondRight{width: 60%; padding: 20px 0 20px 45px;}.fourth .firstLeft{padding: 0 0 20px; width: 100%;}/*fifth*/.fifth{background: white;}.fifth .secondRight{width: 54%; padding: 20px 0 20px 45px;}.fifth .firstImg{width: 44%; padding: 65px 10px 10px;}/*sixth*/.sixth .firstLeft{padding: 0 0 20px; width: 100%; float: right;}.First .firstLeft ul li:before{position: absolute; content: url("../images/star.png"); left: -35px;}.third .firstLeft ul li:before{position: absolute; content: ""; height: 4px; width: 10px; background: #5d5d5d; left: -20px; top: 16px; display: none;}.fourth .firstLeft ul li:before{position: absolute; content: ""; height: 4px; width: 10px; background: #5d5d5d; left: -20px; top: 16px; display: none;}.second .firstLeft ul li:before{position: absolute; content: ""; height: 4px; width: 10px; background: #5d5d5d; left: -20px; top: 16px; display: none;}.topBlocks{width: 32%; display: inline-block; vertical-align: top; text-align: center; padding: 0 25px; margin: 25px 0;}.imageDiv img{width: 100%;}.topBlocks h4{font-weight: 600;}.topBlocks h5{font-size: 15px; position: relative;}.priceDiv span{position: relative;}.priceDiv span:after{position: absolute; content: ""; background: rgba(255, 0, 0, 0.41); height: 3px; width: 100%; -webkit-transform: rotate(-11deg); -moz-transform: rotate(-11deg); -o-transform: rotate(-11deg); -ms-transform: rotate(-11deg); transform: rotate(-11deg); bottom: 8px; left: 0; right: 0;}.priceDiv span:before{position: absolute; content: ""; background: rgba(255, 0, 0, 0.41); height: 3px; width: 100%; -webkit-transform: rotate(11deg); -moz-transform: rotate(11deg); -o-transform: rotate(11deg); -ms-transform: rotate(11deg); transform: rotate(11deg); bottom: 8px; right: 0; left: 0;}.topBlocks h6{font-size: 15px; position: relative;}.topBlocks h5:after{position: absolute; content: ""; background: rgb(255, 0, 0); height: 5px; width: 53%; left: 0; right: 0; margin: 0 auto; bottom: -21px;}.bottomHeading{width: 100%; clear: both; overflow: hidden; padding: 50px 134px;}.bottomHeading h2{font-size: 42px; font-weight: 700; margin: 23px 0; line-height: 54px; letter-spacing: 1px;}.bottomHeading .buttonDiv{padding: 50px 0;}.secondRight .headerText h2 span{font-weight: 600; letter-spacing: -1px; font-size: 31px; color: #000;}.sixth .secondRight .headerText h2{text-align: left;}.NewImg{position: absolute; right: 0; top: 10%;}.fourth .NewImgTwo{top: 13%; position: absolute; right: 0; width: 40%;}.fifth .NewImgThree{position: absolute; right: 0; bottom: 0; /* width: 50%; */}.NewImgFour{position: absolute; right: 0; bottom: 0; /* width: 50%; */}.fourth.sixth .secondRight{float: right;}.fifth .NewImgFour{position: absolute; left: 43%; bottom: 24%; width: 18%;}.second .secondRight .headerText h2 span{letter-spacing: -1px; font-size: 31px; color: #000; font-family: 'Open Sans'; font-weight: 300;}.logoSec{width: 80%; padding: 40px 0 10px; margin: 0 auto;}.logoSec img{width: 240px;}.googleForm{display: none;}.sixth{background: #fff;}.headerTextNew h2{text-align: left;}.rightImg{position: absolute; left: 63%; bottom: -24px; width: 20%;}.rightImg img{width: 100%;}.third .TworightImg{width:20%;}.fourth .secondLeft{width: 48%; right: 0; position: absolute; bottom: 15%;}.seventh{width: 100%; clear: both; overflow: hidden; background: #f5f4f9; padding: 15px 0 0;}.seventh img{width: 100%;}.seventh .secImg img{width: 78%;}.firstImg.NewImg img{width: 50%;}@media (max-width: 1360px){.firstImg.TworightImg img{width: 94%;}.fourth .secondLeft{bottom: 24%;}.firstImg.NewImg img{width: 65%;}.firstLeft{width: 53%; padding: 30px 0 20px;}.third .firstLeft{width: 50%;}.fourth .NewImgTwo{top: 17%;}}@media (max-width: 1200px){.firstImg.NewImg img{width: 51%;}.headerText h2{margin: 14px 0;}.headerText h2{font-size: 35px;}.firstLeft{padding: 34px 0 20px; width: 57%;}.firstLeft ul li{font-size: 27px;}.buttonDiv{padding: 10px 0 0;}.secondRight{padding: 0px 0 20px 0; width: 59%;}.secondRight .headerText h2{line-height: 60px; font-size: 32px;}.third .firstLeft ul li{font-size: 27px;}.sixth .firstLeft{width: 92%;}.fifth .secondRight{padding: 20px 0 20px 10px;}.second .firstLeft ul li{font-size: 26px;}.secondRight .headerText h2{line-height: 54px; font-size: 31px;}.containerNew{width: 85%;}.fourth .secondRight{padding: 20px 0 20px 30px;}.sixth .secondRight .headerText h2{text-align: left;}.logoSec img{width: 180px;}.topBlocks h4{font-size: 20px; min-height: 50px;}.topBlocks h6{font-size: 14px;}.imageDiv{min-height: 188px;}.bottomHeading{padding: 15px 25px;}.bottomHeading h2{font-size: 38px; line-height: 52px;}.buttonDiv button{font-size: 21px;}.second .secondRight .headerText h2 span{font-size: 27px;}.firstLeft ul li{line-height: 42px;}.firstImg.TworightImg img{width: 94%;}.fourth .secondLeft{bottom: 18%;}.fourth .NewImgTwo{top: 11%;}}@media (max-width: 1024px){.headerText h2{font-size: 30px;}.firstLeft{padding: 20px 0 20px;}.firstLeft ul li{font-size: 26px;}.buttonDiv button{font-size: 18px;}.secondRight .headerText h2{line-height: 48px; font-size: 30px;}.second{padding: 40px 0 40px;}.third .secondRight .headerText h2{line-height: 30px;}.third .firstLeft ul li{font-size: 25px;}.topBlocks h6{font-size: 13px;}.bottomHeading h2{font-size: 34px;}.secondRight .headerText h2 span{font-size: 25px;}.firstLeft ul li{line-height: 33px;}}@media (max-width: 992px){.headerText h2{font-size: 26px;}.firstLeft ul li{font-size: 20px;}.buttonDiv button{font-size: 16px;}.First{padding: 40px 0 36px;}.secondRight .headerText h2{line-height: 40px; font-size: 26px;}.second .firstLeft ul li{font-size: 20px;}.third .firstLeft ul li{font-size: 20px;}.containerNew{width: 90%;}.secondRight .headerText h2{line-height: 42px; font-size: 24px;}.firstLeft ul{padding-left: 18px;}.logoSec img{width: 140px;}.topBlocks h4{font-size: 17px;}.topBlocks h6{min-height: 28px;}.bottomHeading h2{font-size: 30px; line-height: 42px;}.bottomHeading .buttonDiv{padding: 37px 0;}.second .secondRight .headerText h2 span{font-size: 24px;}.fourth .NewImgTwo{top: 10%; right: 13%;}.sixth .secondRight .headerText h2{font-size: 30px;}.sixth .firstImg img{padding-top: 140px;}.sixth .secondRight .headerText h2{text-align: left; line-height: 32px;}.imageDiv{min-height: 135px;}.firstImg.NewImg img{width: 65%;}}@media (max-width: 768px){}@media (max-width: 767px){.firstImg img{width: 56%;}.fourth .secondLeft{width: 100%; position: relative;}.firstLeft{width: 100%;}.firstLeft ul li{line-height: 26px;}.rightImg{display: none;}.headerText h2{font-size: 20px; padding: 0 10px;}.third .firstLeft{padding: 0px 18px 0px; width: 100%;}.firstLeft ul li{font-size: 14px;}.firstImg{width: 100%; padding: 0px 10px 10px;}
    .secondRight{width: 100%; padding: 0;}.secondRight .headerText h2{line-height: 33px; font-size: 19px;}.second .firstLeft ul li{font-size: 14px;}.third .secondRight{width: 100%;}.third .firstLeft ul li{font-size: 15px;}.third .firstLeft ul li:before{top: 8px;}.second .firstLeft ul li:before{top: 8px;}.third{padding: 20px 0;}.third .firstImg{width: 100%; margin: 25px 0 0; text-align: center;}.fourth{padding: 20px 0;}.fourth .firstImg{width: 100%;}.fourth .secondRight{padding: 0px 0 0px 5px; width: 100%;}.sixth .secondRight .headerText h2{text-align: left;}.First{padding: 20px 0 36px;}.sixth .secondRight .headerText h2{line-height: 33px; font-size: 19px;}.sixth .firstImg img{width: 82%;}.topBlocks{width: 100%; margin:0;}.topBlocks h4{min-height: auto;}.topBlocks h6{min-height: auto;}.topBlocks{width: 100%; margin-top: 20px;}.topBlocks:nth-child(2){border-left:0 !important; border-right:0 !important; border-top:1px solid #ccc !important; border-bottom:1px solid #ccc !important; padding:10px 0 20px;}.bottomHeading{padding: 15px 0px;}.bottomHeading h2{font-size: 23px; line-height: 34px;}.bottomHeading .buttonDiv{padding: 25px 0;}.second .secondRight .headerText h2 span{font-size: 22px;}.NewImg{position: relative;}.secondRight .headerText h2 span{font-size: 19px;}.third .secondRight .headerText h2{line-height: 24px;}.fourth .NewImgTwo{position: relative;}.fifth .NewImgThree{position: relative;}.fifth .NewImgFour{position: relative;}.fifth .firstImg{padding: 15px 10px 10px;}.sixth .firstImg img{padding-top: 10px;}.seventh .secImg img{width: 54%; padding-top: 23px; margin: 0 auto;}.secImg{text-align: center;}.firstImg.TworightImg img{width: 62%;}}@media (max-width: 500px){}</style> </head> <body ><div className="pulseContentWrap"><div className="container"><div className="contentHead">Welcome to digIMAte</div><div className="contentSubHead">The Digital Clinic Management Solution from IMA PEPS Kerala! </div><div className="col-md-6"><div className="pulseLeftImg"><img alt="" src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/IMA-Plus.jpg"></div></div><div className="col-md-6" id="pulseContentSec"></div></div></div><section> <div className="container"> <div className="iconSection"> <div className="contentHead">What Members Receive</div><div className="container"> <div className="iconTab"> <div className="icon"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/q-left.png" className="qleft"></div><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/drrishin.jpg"> <h4>Dr Rishin Suman</h4> <h6>Take Care Super Speciality Clinic </h6> <h6>Thrissur</h6> <p>Need of the hour is data analysis and research, Need of the hour is medical digitisation, Hence Need of the hour is IMA DIGIMATE.</p></div><div className="iconTab"> <div className="icon"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/q-left.png" className="qleft"></div><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/drpradeep.jpg"> <h4>Dr Pradeep Kumar R</h4> <h6>Senior Consultant Cardiothoracic Surgeon </h6> <h6>Ananthapuri Hospital and Research Institute </h6> <p>Special thanks to a very talented, creative, supportive programmers and developers for launching us into a totally professional digital platform - DIGIMATE for patient care and support with exciting easy to use features scripting a smooth interface in the realm of technological sophistication. Quick, efficient and simple mobile app would be a boon to patients. Highly recommended.</p></div><div className="iconTab"> <div className="icon"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/q-left.png" className="qleft"></div><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/roshni.jpg"> <h4>Dr Roshini Ambat</h4> <h6>Senior Consultant Obst & Gynaec KIMS </h6> <p>Special thanks to a very talented, creative, supportive programmers and developers for launching us into a totally professional digital platform - DIGIMATE for patient care and support with exciting easy to use features scripting a smooth interface in the realm of technological sophistication. Quick, efficient and simple mobile app would be a boon to patients. Highly recommended.</p></div></div></div></div></section> <div className="coverWrap"> <div className="topSec"> <div className="headerText"> <h2>Supercharge Your Practice</h2> </div><div className="containerNew"> <div className="topBlocks"> <h4>Your Own Branded Website</h4> <h6>Be Online & Be Unique</h6> <div className="imageDiv"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/1.png"></div><div className="buttonDiv"> <button type="submit" ><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div><div className="topBlocks"> <h4>Your Own Branded Mobile App</h4> <h6>Includes Telehealth Technology</h6> <div className="imageDiv"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/2.png" ></div><div className="buttonDiv"> <button type="submit" ><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div><div className="topBlocks"> <h4>Practice Management</h4> <h6>Full Featured & Robust</h6> <div className="imageDiv"><img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/3.png"></div><div className="buttonDiv"> <button type="submit"><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div></div></div><div className="second"> <div className="containerNew"> <div className="headerText"> <h2>Branded Website</h2> </div><div className="firstLeft"> <div className="headerText headerTextNew"> <h2><span>Features</span></h2> </div><ul> <li>Choose from templates or your own design</li><li>You decide on your own colours and branding</li><li>Patient Booking available </li><li>Includes Doctor Profile(s) module</li><li>Image Galleries and Videos can be added</li><li>Mobile Friendly & Responsive Designs </li></ul> </div><div className="firstImg NewImg"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/11.png"> </div><div className="buttonDiv"> <button type="submit" ><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div></div><div className="third"> <div className="containerNew"> <div className="headerText "> <h2> Branded Mobile App</h2> </div><div className="firstImg"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/12.png"> </div><div className="firstLeft"> <div className="headerText headerTextNew"> <h2><span>Features</span></h2> </div><ul> <li>Increase your practice revenues with telehealth technology</li><li>Paid chat consultation</li><li>Paid mail consultation</li><li>In-person appointment booking</li><li>Google Android & Apple iOS available</li><li>Your own brand logos & colours</li></ul> </div><div className="firstImg TworightImg"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/13.png"> </div><div className="rightImg"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/14.png"> </div><div className="buttonDiv"> <button type="submit" ><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div></div><div className="fourth"> <div className="containerNew"> <div className="headerText"> <h2>Practice Management Software</h2> </div><div className="secondRight"> <div className="firstLeft "> <div className="headerText headerTextNew"> <h2><span>Full featured & Robust</span></h2> </div><ul> <li>Patient Electronic Health Records (EHR)</li><li>Appointment calendar</li><li>Online & in-person appointment</li><li>Specialized case sheets</li><li>Prescriptions</li><li>Procedure Management</li><li>Treatment plan creation</li><li>Graphical vital-signs tracking</li><li>Automated SMS reminders </li><li>Analytics and reporting</li><li>Medical consent forms</li></ul> </div><div className="firstImg NewImgTwo"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/15.png"> </div><div className="firstLeft secondLeft"> <ul> <li>Patient health cards</li><li>Billing & GST</li><li>Multiple Doctor & staff logins</li><li>Lab-order management</li><li>Pharmacy Management</li><li>Inventory, Income & Expense tracking</li></ul> </div></div><div className="buttonDiv"> <button type="submit"><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div></div><div className="fourth sixth"> <div className="containerNew"> <div className="firstImg"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/18.png"> </div><div className="secondRight"> <div className="headerText"> <h2>Your data is safe</h2> <h2><span>Fully-Secure Cloud Technology</span></h2> </div><div className="firstLeft"> <ul> <li>Uses Industry Leading Security</li><li>Uses Amazon Web Services</li><li>Automated backups</li><li>Device based logins</li><li>Your data is yours & fully explorable</li></ul> </div></div><div className="buttonDiv"> <button type="submit"><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div></div><div className="seventh"> <div className="containerNew"> <div className="headerText"> <h2>Special Limited Time Offer</h2> </div><div className="col-md-4 col-sm-4 col-xs-12"> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/4.png"> </div><div className="col-md-4 col-sm-4 col-xs-12"> <div className="buttonDiv"> <button type="submit"><a href="https://www.idaksbassist.com/?register=register">SIGN UP NOW</a></button> </div></div><div className="col-md-4 col-sm-4 col-xs-12 secImg "> <img src="https://s3.amazonaws.com/purplehealthfiles/production/pulse/innerHtmlImages/10.png"> </div></div></div></div></body></html>`);
  const [logoPath, setlogoPath] = useState("");
  const [name, setname] = useState("");
  const [price, setprice] = useState("");
  const [seoDescription, setseoDescription] = useState("");
  const [pulseNameData, setpulseNameData] = useState("");
  const [pulseSiteUrl, setpulseSiteUrl] = useState(
    "https://pulse.purplehealth.com/GROUP-xx"
  );
  const [pulseTitle, setpulseTitle] = useState("");
  const [seoKeywords, setseoKeywords] = useState("");
  const [seoTitle, setseoTitle] = useState("");
  const [title, settitle] = useState("");
  const [siteUrl, setsiteUrl] = useState(
    "https://appapi.purplehealth.com/COMPANY-xx"
  );
  const [slug, setslug] = useState("");
  const [smsGatewayId, setsmsGatewayId] = useState("");
  const [smsGatewayEntityId, setsmsGatewayEntityId] = useState("");
  const [smsSenderId, setsmsSenderId] = useState("PURPLe");
  const [smsTitle, setsmsTitle] = useState("");
  const [hasChat, sethasChat] = useState(false);
  const [prNumberEnabled, setprNumberEnabled] = useState(false);
  const [videoChatCommission, setvideoChatCommission] = useState("");
  const [audioChatCommission, setaudioChatCommission] = useState("");
  const [textChatCommission, settextChatCommission] = useState("");
  const [isNetworkEnabled, setisNetworkEnabled] = useState(false);
  const [chatCode, setchatCode] = useState("");
  const [registrationMailText, setregistrationMailText] = useState("");
  const [welcomeText, setwelcomeText] = useState("");
  const [emrStatus, setemrStatus] = useState(0);
  const [grpHosAdmId, setgrpHosAdmId] = useState(0);
  const [displayName, setdisplayName] = useState("");
  const [groupPassword, setgroupPassword] = useState("password");
  const [enabled, setenabled] = useState("true");
  const [groupEmailId, setgroupEmailId] = useState("");
  const [hospitalId, sethospitalId] = useState("");
  const [hospName, sethospName] = useState("");
  const [userTitle, setuserTitle] = useState("");
  const [groupHosAdminId, setgroupHosAdminId] = useState("");
  const [doctorId, setdoctorId] = useState("");
  const [doctorName, setdoctorName] = useState("");
  const [themeName, setthemeName] = useState("");
  const [themeId, setthemeId] = useState("");
  const [parentSiteId, setparentSiteId] = useState("");
  const [registraionTerms, setregistraionTerms] = useState("");
  const [emailConsultTerms, setemailConsultTerms] = useState("");
  const [pulseSessionTimeOutUrl, setpulseSessionTimeOutUrl] = useState("");
  const [sessionTimeOutUrl, setsessionTimeOutUrl] = useState("");
  const [pulseSlug, setpulseSlug] = useState("");
  const [grievancesEmailId, setgrievancesEmailId] = useState("");
  const [myyShoppGroupId, setmyyShoppGroupId] = useState("");
  const [hasPatientLogin, sethasPatientLogin] = useState(true);
  const [hasServices, sethasServices] = useState(true);
  const [userRegisterMode, setuserRegisterMode] = useState("0");
  const [patientDashBoard, setpatientDashBoard] = useState("");
  const [advertisementScript, setadvertisementScript] = useState("");
  const [awsEndPoint, setawsEndPoint] = useState(
    "https://sns.us-east-1.amazonaws.com"
  );
  const [awsRegion, setawsRegion] = useState("us-east-1");
  const [isDoctorHomePageCalendar, setisDoctorHomePageCalendar] =
    useState(false);
  const [showDoctorTiming, setshowDoctorTiming] = useState(false);
  const [address, setaddress] = useState("");
  const [themeColor, setthemeColor] = useState("");
  const [availPromotionalSmsCount, setavailPromotionalSmsCount] =
    useState("10000");
  const [availTransactionalSmsCount, setavailTransactionalSmsCount] =
    useState("10000");
  const [totalPromotionalSmsCount, settotalPromotionalSmsCount] =
    useState("10000");
  const [totalTransactionalSmsCount, settotalTransactionalSmsCount] =
    useState("10000");
  const [promotionalSmsValidFrom, setpromotionalSmsValidFrom] = useState(today);
  const [promotionalSmsValidTo, setpromotionalSmsValidTo] =
    useState(twoYearAfterToday);
  const [transactionalSmsValidFrom, settransactionalSmsValidFrom] =
    useState(today);
  const [transactionalSmsValidTo, settransactionalSmsValidTo] =
    useState(twoYearAfterToday);
  const [privacyPolicy, setprivacyPolicy] = useState("");
  const [termsAndCondition, settermsAndCondition] = useState("");
  const [doctorAppPrivacyPolicy, setdoctorAppPrivacyPolicy] = useState("");
  const [doctorAppTermsAndCondition, setdoctorAppTermsAndCondition] =
    useState("");
  const [hasHealthTracker, sethasHealthTracker] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [isidalogin, setisidalogin] = useState(false);
  const [doctorRegistrationCount, setdoctorRegistrationCount] = useState("0");
  const [appLogoUrl, setappLogoUrl] = useState("");
  const [appWelcomeScreenImageUrl, setappWelcomeScreenImageUrl] = useState("");
  const [loginBackgroundUrl, setloginBackgroundUrl] = useState("");
  const [fbPixel, setfbPixel] = useState("");
  const [projectName, setprojectName] = useState("");
  const [isThemeBased, setisThemeBased] = useState(false);
  const [hospitalWorkingTime, sethospitalWorkingTime] = useState("");
  const [mobileNumber, setmobileNumber] = useState("");
  const [bookAppointmentTerms, setbookAppointmentTerms] =
    useState(`<div className="terms-wrapper terms-wrapper-popup"><p className="terms-p-bold">This is the Terms of Service for this website or mobile app and associated clinic.</p><p className="terms-p-bold">Please note that this service should not be used for medical emergencies. If there is an immediate medical issue users should go to a proper and accredited health care provider in-person.</p><p className="terms-p-bold">In addition, in order to use any of our services or to engage with a medical professional, users must be 18+ Years of age and Citizens of India.</p><p className="terms-p-bold">General</p><p>Please read this Terms of Service policy and in order to use our products and services. By use of our products and services you acknowledge that you have read, understood and have irrevocably agreed to our following Terms of Service conditions and agree to be bound to our <span className="terms-p-bold">Terms of Service</span> by contractual terms, as well as to our <span className="terms-p-bold">Privacy Policy</span>.</p><p className="terms-p-bold">Definitions</p><p>"We", "Our", "Us" - refers to the owner(s) of this website, mobile app and its associated clinic.</p><p>"You", "Your", "User", "Patient", "Client" - refer to the individual User of the mobile app or website and its associated services.</p><p>"Health Care Provider" or "HCP" "Provider" - refers to Doctors, Clinicians, Therapists or any other health and medical professional, expert, consultant or practitioner that may be using the platform or service.</p><p>"Health Care Partner", "Affiliate", "Partner", "Service Provider" - refer to associated partners that we may engage with or whose services that we use such as health care providers, clinics, hospitals, labs, pharmacies, insurance companies, medical device & equipment providers, third party technology providers or any third party service providers that we may engage with in order to provide services for the User of the apps & website.</p><p>"Personal Information", "Personally Identifiable Information", "PII" - refer to information that you provide us that identifies you like: </p><ul><li> <p>Name, Phone Number, Home Address, Email address.</p> </li><li><p>Financial Information like Bank Accounts</p></li></ul><p>"Personal Health Information", "PHI" - refer to information that you provide us in regards to your health like:</p><ul><li><p>Medical information: age, gender, information on your medical conditions, information on your health related issues</p></li></ul><p>"Digital Health Platform", "Platform" - refer to the mobile app or website and the underlying technology being used by users in order to access or engage with Health Care Partners and Health Care Providers who provide Digital Health Services.</p><p>"Digital Health Services", "Health Services", "Services" - Refers to the key functions offered by the Digital Health Platform eg. Booking an appointment with a doctor, Telehealth consultations, Sending of Prescriptions, Creation of an Electronic Health Records and any other medical or health related service enabled by the Platform</p><p>"Telehealth", "Telemedicine" - refers to remote consultation between a patient and a Health Care Provider (eg. a doctor) via phone-call, video-call, email, or text/message chat.</p><p className="terms-p-bold">What this Service is For</p><p>This service is primarily designed to help users connect to healthcare providers and medical professionals & practitioners (eg.like doctors) in order to book in-clinic appointments, engage in remote telehealth consultations (eg. video-consult, audio/phone consult or message-chat)  and to facilitate any engagement between users and the healthcare providers that are accessible on our service.</p><p className="terms-p-bold">Please note that this service should not be used for medical emergencies. If there is an immediate medical issue users should go to a proper and accredited health care provider in-person.</p><p className="terms-p-bold">In addition, in order to use any of our services or to engage with a medical professional, users must be 18+ Years of age and Citizens of India.</p><p className="terms-p-bold">Partners & Affiliates</p><p>Any advice or recommendation is not endorsed by our technology partners, affiliates or service providers in any capacity. You acknowledge understanding and agreeing to this fact and you agree that they have no liability to you in any manner or capacity for your use of our services, regardless of outcomes.</p><ul><li><p>Our services may provide information in the form of articles, videos, graphics or links to other websites and content. Some of the content may be provided by healthcare professionals. Our partners do not endorse or recommend any information, tests, procedures, as viewed on our platforms, services, websites or apps.</p></li><li><p>The Information and Services that we provide or that of our partners, affiliates, associated service providers or licensors are provided on an "as is" and "as available' basis, and without any warranties or conditions (express or implied, including the implied warranties of merchantability, accuracy, or fitness for a particular purpose). To the fullest extent of the law possible, they shall in no event be liable to you or any party or user in regards to any actions taken by you based on any information found on our services provided by us, other users or third parties or partners. As well, the use of any information to verify credentials or healthcare providers or practitioners is not approved by us and is prohibited.</p></li><li><p>We or our partners and affiliates 
      do not endorse or recommend any information on third party websites or apps that may be linked to from our service.</p></li><li><p>You should only follow a course of action that you have discussed with a qualified doctor or medical professional and not simply by following any content viewed on this service. You understand and agree to this fact. Only you are responsible for the information or advice that you follow and you agree that we or our partners are not responsible in any way for the consequences of your actions.</p></li></ul><p className="terms-p-bold">Unapproved Uses of Our Service</p><p>You agree to not copy our information, content, details of our partners, healthcare providers, details of healthcare professionals whether logged in our logged out of our service, through manual or automated means.</p><p>In general you agree to not use our services in a manner other than what it is intended for - namely for you (or your family) to get access to health care professionals and for viewing content on healthcare information. No other use of our services is acceptable.</p><p className="terms-p-bold">Limitations of Liability & Indemnification</p><p>You agree to not include our technology partners in any legal action in relation to your health for any advice that you have taken or any health related action or medical procedure that you have embarked on using our services.</p><p>Should you add your dependent's personal and/or health information to the services then you are responsible for the information that you provide including ensuring that you have permission to do so and that the information is correct. You agree that you are liable for misinformation, lack of permission to share any personal information of a dependent and that you indemnify us in case of any claim or liability that arises from improper or unauthorized use of such information.</p><p>You agree that the maximum liability that we have is the amount that you may have paid for an appointment directly through our platform for services or Rs. 1000 at a maximum.</p><p className="terms-p-bold">You Are Responsible For Your Account</p><p>You agree to keep your login, password and account details private at all times. You agree that we are not responsible for any hacking or breach of your account due to any sharing of your account or password information. You must keep your information private at all times.</p><p>Furthermore, you must not use someone else's credentials and access their account.</p><p>If you suspect that someone else has your credentials, account information and is using your account, you must contact us immediately and inform us. Please email support@purplehealth.com.</p><p className="terms-p-bold">Your Data and Information that You Provide</p><p className="terms-p-bold">Please read our Privacy Policy for more details on how we handle your data.</p><ul><li><p>Note that we do not sell your personal health data or personal identifying data to anyone.</p></li><li><p>You do agree to let us share your data with health care practitioners, healthcare providers or partners & affiliates in order to facilitate booking an appointment, for a telehealth consultation, for appointment rescheduling or cancellation, e-prescriptions or for any action relevant to providing our services to you.</p></li><li><p>You understand and acknowledge that we have no control over or have any liability as it relates to personal information or personal health information that you choose to give to a healthcare provider or healthcare practitioner, using our platform and services.</p></li><li><p>You may voluntarily choose to use services such as uploading a personal health record to the platform or wish to receive health records such as prescriptions from the healthcare provider that you choose to engage with, such as a doctor. This information can be sent through email, SMS and similar means whose details you provide us and the healthcare provider and practitioner for this purpose. Should you provide a wrong email or phone number to which this information is sent, we are not liable in any way for the wrong party receiving this information. It is up to you to ensure that the information that you provide is 100% accurate.</p></li><li><p>In addition, should you change your number or give it up, you must update your information with us. You agree that we are not responsible for any issues or problems 
      arising with you not informing us of any changes in your contact details and updating your information on the platform.</p></li></ul><p className="terms-p-bold">Suspension or Termination of Account</p><p>We reserve the right to suspend or cancel an account for any reason, including:</p><ul><li><p>Harassment of others including healthcare providers and healthcare practitioners</p></li><li><p>Booking of appointments and not attending the appointment after booking. Typically, though not always, we will suspend an account after 3 such occurrences</p></li><li><p>Sending purposely misleading information to our partner healthcare providers or practitioners</p></li><li><p>Using the system to surveil our partners</p></li><li><p>Copying our Intellectual Property</p></li><li><p>Scraping data from our services</p></li><li><p>Using an account that does not belong to you.</p></li><li><p>Trying to get credentials of accounts that do not belong to you.</p></li><li><p>Any other reason that we see fit.</p></li></ul><p>Should you wish to delete your account please email <a href="mailTo:support@purplehealth.com">support@purplehealth.com</a>.</p><p className="terms-p-bold">Notifications and Communications</p><ul><li><p>In order to remind you of appointments, booking confirmations, telehealth consultations, cancelled appointments or for any reason related to our services, you agree to allow us to send you notices and information by SMS, in-app mobile push notifications, browser notifications, messages, emails or phone calls. You may manage these notifications as appropriate in any available settings in our services related to notifications or in your mobile phone or computer device & browser settings.</p></li><li><p>Should you opt out of receiving notifications, you acknowledge that you may miss important notifications such as reminders for events. In addition, should you opt out of notifications and communications, the services may not work properly or may not work at all.</p></li><li><p>You also agree that we may send your Personal Information or Personal Health Information when you use our services to consult with a healthcare provider or healthcare professional such as a doctor. We may send information via email, sms, in-app push-notification as it relates to prescriptions, lab-orders, medical advice and related services which you have voluntarily expressly opted into and consented to allow. Should these communications be intercepted or viewed by someone else, while unlikely, you agree to release us from any liability arising from any interception or unauthorized access.</p></li></ul><p className="terms-p-bold">Ownership, Trademarks and Copyrights</p><ul><li><p>All of the software, content and intellectual property is owned by us or has been licensed by us. We give users such as yourself a limited permission to use our services and access our content. This does not give any permanent access or re-sale or commercial rights to our content or services. You agree to not try to copy, sell or license our content or services or any of our intellectual property.</p></li></ul><p className="terms-p-bold">User Generated Content</p><p>There may be parts of our service or platform that allows for user generated. In those instances:</p><ul><li><p>As a user, you agree that any user generated content shall automatically be licensed to us free of charge and free of any legal, trademark or intellectual property encumbrances and free for us to use, should we wish to use it, at any time without any required payment of any sort and in any manner that we choose. This is a perpetual, worldwide license.</p></li><li><p>You also agree to not upload or save any trademarked content on our services or platforms and that we are not liable for any such misuse by you and that you indemnify us for any IP or trademarked content that is uploaded by you.</p></li><li><p>You agree that we are not liable for any of the content uploaded by users. As expressed elsewhere in the Terms of Service, we express no warranties or recommend any such content to follow or believe, which has been stated in other parts of this Terms of Service.</p></li><li><p>You agree to not upload pornography, illegal content or any other content that may harm others, damage the service or platform in any way such as malicious code or anything similar.</p></li><li><p>You also agree that we are free to delete or modify any such content that is posted or uploaded by you.</p></li></ul><p className="terms-p-bold">Severability</p><p>If any part of the Agreement is held by a legal court, or legal arbitrator, to be unenforceable then that provision will be excluded but this shall not invalidate the rest of the agreement which shall remain and considered to be valid.</p><p className="terms-p-bold">We May Update This Agreement</p><p>You acknowledge, understand and agree that we may update these Terms of Service from time to time and that the latest Terms of Service will be in effect. We may require you to re-accept the Terms of Use from time to time if we feel that the changes have been substantial enough to warrant that effort.</p><p className="terms-p-bold">Jurisdiction and Disputes</p><p>This Agreement is governed by the Laws of India and any legal dispute shall be resolved in the State of Kerala in the City of Thiruvananthapuram.</p><p>The dispute resolution method shall be by arbitration for which we (or based on its approval a partner or affiliate) will appoint an arbitrator and the arbitration shall be conducted in English in accordance with the Arbitration and Conciliation Act, 1996.</p></div>`);
  const [pulseRegistraionTerms, setpulseRegistraionTerms] = useState("");
  const [videoChatTerms, setvideoChatTerms] =
    useState(`<div className="terms-wrapper terms-wrapper-popup"><p className="terms-p-bold">This is the Terms of Service for this website or mobile app and associated clinic.</p><p className="terms-p-bold">Please note that this service should not be used for medical emergencies. If there is an immediate medical issue users should go to a proper and accredited health care provider in-person.</p><p className="terms-p-bold">In addition, in order to use any of our services or to engage with a medical professional, users must be 18+ Years of age and Citizens of India.</p><p className="terms-p-bold">General</p><p>Please read this Terms of Service policy and in order to use our products and services. By use of our products and services you acknowledge that you have read, understood and have irrevocably agreed to our following Terms of Service conditions and agree to be bound to our <span className="terms-p-bold">Terms of Service</span> by contractual terms, as well as to our <span className="terms-p-bold">Privacy Policy</span>.</p><p className="terms-p-bold">Definitions</p><p>"We", "Our", "Us" - refers to the owner(s) of this website, mobile app and its associated clinic.</p><p>"You", "Your", "User", "Patient", "Client" - refer to the individual User of the mobile app or website and its associated services.</p><p>"Health Care Provider" or "HCP" "Provider" - refers to Doctors, Clinicians, Therapists or any other health and medical professional, expert, consultant or practitioner that may be using the platform or service.</p><p>"Health Care Partner", "Affiliate", "Partner", "Service Provider" - refer to associated partners that we may engage with or whose services that we use such as health care providers, clinics, hospitals, labs, pharmacies, insurance companies, medical device & equipment providers, third party technology providers or any third party service providers that we may engage with in order to provide services for the User of the apps & website.</p><p>"Personal Information", "Personally Identifiable Information", "PII" - refer to information that you provide us that identifies you like: </p><ul><li> <p>Name, Phone Number, Home Address, Email address.</p> </li><li><p>Financial Information like Bank Accounts</p></li></ul><p>"Personal Health Information", "PHI" - refer to information that you provide us in regards to your health like:</p><ul><li><p>Medical information: age, gender, information on your medical conditions, information on your health related issues</p></li></ul><p>"Digital Health Platform", "Platform" - refer to the mobile app or website and the underlying technology being used by users in order to access or engage with Health Care Partners and Health Care Providers who provide Digital Health Services.</p><p>"Digital Health Services", "Health Services", "Services" - Refers to the key functions offered by the Digital Health Platform eg. Booking an appointment with a doctor, Telehealth consultations, Sending of Prescriptions, Creation of an Electronic Health Records and any other medical or health related service enabled by the Platform</p><p>"Telehealth", "Telemedicine" - refers to remote consultation between a patient and a Health Care Provider (eg. a doctor) via phone-call, video-call, email, or text/message chat.</p><p className="terms-p-bold">What this Service is For</p><p>This service is primarily designed to help users connect to healthcare providers and medical professionals & practitioners (eg.like doctors) in order to book in-clinic appointments, engage in remote telehealth consultations (eg. video-consult, audio/phone consult or message-chat)  and to facilitate any engagement between users and the healthcare providers that are accessible on our service.</p><p className="terms-p-bold">Please note that this service should not be used for medical emergencies. If there is an immediate medical issue users should go to a proper and accredited health care provider in-person.</p><p className="terms-p-bold">In addition, in order to use any of our services or to engage with a medical professional, users must be 18+ Years of age and Citizens of India.</p><p className="terms-p-bold">Partners & Affiliates</p><p>Any advice or recommendation is not endorsed by our technology partners, affiliates or service providers in any capacity. You acknowledge understanding and agreeing to this fact and you agree that they have no liability to you in any manner or capacity for your use of our services, regardless of outcomes.</p><ul><li><p>Our services may provide information in the form of articles, videos, graphics or links to other websites and content. Some of the content may be provided by healthcare professionals. Our partners do not endorse or recommend any information, tests, procedures, as viewed on our platforms, services, websites or apps.</p></li><li><p>The Information and Services that we provide or that of our partners, affiliates, associated service providers or licensors are provided on an "as is" and "as available' basis, and without any warranties or conditions (express or implied, including the implied warranties of merchantability, accuracy, or fitness for a particular purpose). To the fullest extent of the law possible, they shall in no event be liable to you or any party or user in regards to any actions taken by you based on any information found on our services provided by us, other users or third parties or partners. As well, the use of any information to verify credentials or healthcare providers or practitioners is not approved by us and is prohibited.</p></li><li><p>We or our partners and affiliates 
      do not endorse or recommend any information on third party websites or apps that may be linked to from our service.</p></li><li><p>You should only follow a course of action that you have discussed with a qualified doctor or medical professional and not simply by following any content viewed on this service. You understand and agree to this fact. Only you are responsible for the information or advice that you follow and you agree that we or our partners are not responsible in any way for the consequences of your actions.</p></li></ul><p className="terms-p-bold">Unapproved Uses of Our Service</p><p>You agree to not copy our information, content, details of our partners, healthcare providers, details of healthcare professionals whether logged in our logged out of our service, through manual or automated means.</p><p>In general you agree to not use our services in a manner other than what it is intended for - namely for you (or your family) to get access to health care professionals and for viewing content on healthcare information. No other use of our services is acceptable.</p><p className="terms-p-bold">Limitations of Liability & Indemnification</p><p>You agree to not include our technology partners in any legal action in relation to your health for any advice that you have taken or any health related action or medical procedure that you have embarked on using our services.</p><p>Should you add your dependent's personal and/or health information to the services then you are responsible for the information that you provide including ensuring that you have permission to do so and that the information is correct. You agree that you are liable for misinformation, lack of permission to share any personal information of a dependent and that you indemnify us in case of any claim or liability that arises from improper or unauthorized use of such information.</p><p>You agree that the maximum liability that we have is the amount that you may have paid for an appointment directly through our platform for services or Rs. 1000 at a maximum.</p><p className="terms-p-bold">You Are Responsible For Your Account</p><p>You agree to keep your login, password and account details private at all times. You agree that we are not responsible for any hacking or breach of your account due to any sharing of your account or password information. You must keep your information private at all times.</p><p>Furthermore, you must not use someone else's credentials and access their account.</p><p>If you suspect that someone else has your credentials, account information and is using your account, you must contact us immediately and inform us. Please email support@purplehealth.com.</p><p className="terms-p-bold">Your Data and Information that You Provide</p><p className="terms-p-bold">Please read our Privacy Policy for more details on how we handle your data.</p><ul><li><p>Note that we do not sell your personal health data or personal identifying data to anyone.</p></li><li><p>You do agree to let us share your data with health care practitioners, healthcare providers or partners & affiliates in order to facilitate booking an appointment, for a telehealth consultation, for appointment rescheduling or cancellation, e-prescriptions or for any action relevant to providing our services to you.</p></li><li><p>You understand and acknowledge that we have no control over or have any liability as it relates to personal information or personal health information that you choose to give to a healthcare provider or healthcare practitioner, using our platform and services.</p></li><li><p>You may voluntarily choose to use services such as uploading a personal health record to the platform or wish to receive health records such as prescriptions from the healthcare provider that you choose to engage with, such as a doctor. This information can be sent through email, SMS and similar means whose details you provide us and the healthcare provider and practitioner for this purpose. Should you provide a wrong email or phone number to which this information is sent, we are not liable in any way for the wrong party receiving this information. It is up to you to ensure that the information that you provide is 100% accurate.</p></li><li><p>In addition, should you change your number or give it up, you must update your information with us. You agree that we are not responsible for any issues or problems 
      arising with you not informing us of any changes in your contact details and updating your information on the platform.</p></li></ul><p className="terms-p-bold">Suspension or Termination of Account</p><p>We reserve the right to suspend or cancel an account for any reason, including:</p><ul><li><p>Harassment of others including healthcare providers and healthcare practitioners</p></li><li><p>Booking of appointments and not attending the appointment after booking. Typically, though not always, we will suspend an account after 3 such occurrences</p></li><li><p>Sending purposely misleading information to our partner healthcare providers or practitioners</p></li><li><p>Using the system to surveil our partners</p></li><li><p>Copying our Intellectual Property</p></li><li><p>Scraping data from our services</p></li><li><p>Using an account that does not belong to you.</p></li><li><p>Trying to get credentials of accounts that do not belong to you.</p></li><li><p>Any other reason that we see fit.</p></li></ul><p>Should you wish to delete your account please email <a href="mailTo:support@purplehealth.com">support@purplehealth.com</a>.</p><p className="terms-p-bold">Notifications and Communications</p><ul><li><p>In order to remind you of appointments, booking confirmations, telehealth consultations, cancelled appointments or for any reason related to our services, you agree to allow us to send you notices and information by SMS, in-app mobile push notifications, browser notifications, messages, emails or phone calls. You may manage these notifications as appropriate in any available settings in our services related to notifications or in your mobile phone or computer device & browser settings.</p></li><li><p>Should you opt out of receiving notifications, you acknowledge that you may miss important notifications such as reminders for events. In addition, should you opt out of notifications and communications, the services may not work properly or may not work at all.</p></li><li><p>You also agree that we may send your Personal Information or Personal Health Information when you use our services to consult with a healthcare provider or healthcare professional such as a doctor. We may send information via email, sms, in-app push-notification as it relates to prescriptions, lab-orders, medical advice and related services which you have voluntarily expressly opted into and consented to allow. Should these communications be intercepted or viewed by someone else, while unlikely, you agree to release us from any liability arising from any interception or unauthorized access.</p></li></ul><p className="terms-p-bold">Ownership, Trademarks and Copyrights</p><ul><li><p>All of the software, content and intellectual property is owned by us or has been licensed by us. We give users such as yourself a limited permission to use our services and access our content. This does not give any permanent access or re-sale or commercial rights to our content or services. You agree to not try to copy, sell or license our content or services or any of our intellectual property.</p></li></ul><p className="terms-p-bold">User Generated Content</p><p>There may be parts of our service or platform that allows for user generated. In those instances:</p><ul><li><p>As a user, you agree that any user generated content shall automatically be licensed to us free of charge and free of any legal, trademark or intellectual property encumbrances and free for us to use, should we wish to use it, at any time without any required payment of any sort and in any manner that we choose. This is a perpetual, worldwide license.</p></li><li><p>You also agree to not upload or save any trademarked content on our services or platforms and that we are not liable for any such misuse by you and that you indemnify us for any IP or trademarked content that is uploaded by you.</p></li><li><p>You agree that we are not liable for any of the content uploaded by users. As expressed elsewhere in the Terms of Service, we express no warranties or recommend any such content to follow or believe, which has been stated in other parts of this Terms of Service.</p></li><li><p>You agree to not upload pornography, illegal content or any other content that may harm others, damage the service or platform in any way such as malicious code or anything similar.</p></li><li><p>You also agree that we are free to delete or modify any such content that is posted or uploaded by you.</p></li></ul><p className="terms-p-bold">Severability</p><p>If any part of the Agreement is held by a legal court, or legal arbitrator, to be unenforceable then that provision will be excluded but this shall not invalidate the rest of the agreement which shall remain and considered to be valid.</p><p className="terms-p-bold">We May Update This Agreement</p><p>You acknowledge, understand and agree that we may update these Terms of Service from time to time and that the latest Terms of Service will be in effect. We may require you to re-accept the Terms of Use from time to time if we feel that the changes have been substantial enough to warrant that effort.</p><p className="terms-p-bold">Jurisdiction and Disputes</p><p>This Agreement is governed by the Laws of India and any legal dispute shall be resolved in the State of Kerala in the City of Thiruvananthapuram.</p><p>The dispute resolution method shall be by arbitration for which we (or based on its approval a partner or affiliate) will appoint an arbitrator and the arbitration shall be conducted in English in accordance with the Arbitration and Conciliation Act, 1996.</p></div>`);
  const [doctorDataList, setdoctorDataList] = useState([]);
  const [hospitalData, sethospitalData] = useState([]);
  const [themeData, setthemeData] = useState([]);
  const [siteList, ssetsiteList] = useState([]);
  const [tempHospitalData, settempHospitalData] = useState({
    hospitalId: "",
    hospitalName: "",
  });
  const [tempDoctorData, settempDoctorData] = useState({
    doctorId: 0,
    doctorName: "",
  });
  const [s3bucketAccessKey, sets3bucketAccessKey] = useState("");
  const [AWSAccessKeyId, setAWSAccessKeyId] = useState("");
  const [region, setregion] = useState("us-east-1");
  const [bucket, setbucket] = useState("");
  const [bucketFolder, setbucketFolder] = useState("");
  const [s3BucketAddressPath, sets3BucketAddressPath] = useState("");
  const [pulseLogoPath, setpulseLogoPath] = useState("");
  const [stringHospitalIds, setstringHospitalIds] = useState("");
  const [hospitalIdsList, sethospitalIdsList] = useState([]);
  const [removeHospitalIdsArray, setremoveHospitalIdsArray] = useState([]);
  const [removeHospitalIds, setremoveHospitalIds] = useState("");
  const [removeDoctorIdsArray, setremoveDoctorIdsArray] = useState([]);
  const [removeDoctorIds, setremoveDoctorIds] = useState("");
  const [isParent, setisParent] = useState(false);
  const [adminContactNo, setadminContactNo] = useState("");
  const [adminEmailId, setadminEmailId] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [cmbSelect, setcmbSelect] = useState("");
  const [searchKeyWord, setsearchKeyWord] = useState("");
  const [inPersonAppointmentTimeInterval, setinPersonAppointmentTimeInterval] =
    useState("");
  const [videoAppointmentTimeInterval, setvideoAppointmentTimeInterval] =
    useState("");
  const [callADoctorTimeInterval, setcallADoctorTimeInterval] = useState("");

  useEffect(() => {
    $("#changePassPopup").hide();
    $("#metadataPopup").hide();
    getThemeData();
    getImagePath();
    setmobileNumber(randomMobileNo());
    if (siteId > 0) {
      getSiteDetails();
    }
  }, []);

  const getThemeData = () => {
    $(".loader").show();
    const getThemeListReq = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getThemeList",
      }),
    };
    apiCalling(getThemeListReq).then((data) => {
      if (data.success === "1") {
        setthemeData(data.themeData);
        ssetsiteList(data.siteResult);
        // this.setState({ themeData: data.themeData, siteList: data.siteResult });
      }
      $(".loader").hide();
    });
  };
  const randomMobileNo = () => {
    return "xxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 8) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(8);
    });
  };
  const dateChangeHandler = (date, id) => {
    // this.setState({ [id]: formatDatePickerToddMMyyyy(date) });
    let toDate = addDays(new Date(date), 730);
    if (id === "transactionalSmsValidTo") {
      settransactionalSmsValidTo(formatDatePickerToddMMyyyy(toDate));
    } else if (id === "promotionalSmsValidTo") {
      setpromotionalSmsValidTo(formatDatePickerToddMMyyyy(toDate));
    } else if (id === "transactionalSmsValidFrom") {
      settransactionalSmsValidFrom(formatDatePickerToddMMyyyy(date));
    } else if (id === "promotionalSmsValidFrom") {
      setpromotionalSmsValidFrom(formatDatePickerToddMMyyyy(date));
    }
  };
  const getImagePath = () => {
    let data = imagePathData;
    sets3bucketAccessKey(data.s3bucketAccessKey);
    setAWSAccessKeyId(data.s3bucketSecretKey);
    setbucket(data.PurpleHealthS3bucket);
    setbucketFolder(data.s3BucketRelianceAddressPath);
    sets3BucketAddressPath(data.S3BucketMainFolder);
    setpulseLogoPath(data.pulseLogoPath);
  };
  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const fileUpload = (file, fileFor, subFolder = "") => {
    $(".loader").show();
    AWS.config.update({
      accessKeyId: s3bucketAccessKey,
      secretAccessKey: AWSAccessKeyId,
      region: region,
    });
    let Bucket =
      bucket +
      "/" +
      s3BucketAddressPath +
      "/" +
      pulseLogoPath +
      (subFolder ? "/" + subFolder : "");
    var bucketParams = { Bucket: Bucket };
    s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });
    let S3BucketMainFolder = "";
    let fileName = uuidv4() + file.name;
    fullFilePath = S3BucketMainFolder + fileName;
    imageFile = fileName;
    s3.upload(
      {
        Key: fullFilePath,
        Body: file,
        ACL: "public-read",
      },
      (err, data) => {
        // ;
        if (err) {
          alert("There was an error uploading your File:", err.message);
        } else if (data) {
          if (fileFor === "logoPath") setlogoPath(data.Location);
          else if (fileFor === "favIcon") setfavIcon(data.Location);
          else if (fileFor === "appLogoUrl") setappLogoUrl(data.Location);
          else if (fileFor === "appWelcomeScreenImageUrl")
            setappWelcomeScreenImageUrl(data.Location);
          else if (fileFor === "loginBackgroundUrl")
            setloginBackgroundUrl(data.Location);
          //   this.setState({ [fileFor]: data.Location });
        }
        $(".loader").hide();
      }
    );
  };

  const fileChange = (e) => {
    let fileFor = $("#" + e.currentTarget.id).attr("fileFor");
    let subFolder = $("#" + e.currentTarget.id).attr("subFolder");
    imageFile = e.target.files[0];
    if (!imageFile.name.match(/\.(jpg|jpeg|png|ico)$/)) {
      alert("Add file(s) with only JPG,JPEG,PNG format");
      return false;
    }
    if (imageFile.size > 3145728) {
      alert("File size must under 3 MB!");
      return false;
    } else {
      fileUpload(e.target.files[0], fileFor, subFolder);
      imageFile = null;
    }
  };
  const isNumber = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      let id = e.target.id;
      if (id === "price") setprice(e.target.value);
      else if (id === "totalTransactionalSmsCount")
        settotalPromotionalSmsCount(e.target.value);
      else if (id === "totalPromotionalSmsCount")
        settotalPromotionalSmsCount(e.target.value);
      else if (id === "availTransactionalSmsCount")
        setavailTransactionalSmsCount(e.target.value);
      else if (id === "availPromotionalSmsCount")
        setavailPromotionalSmsCount(e.target.value);

      //   this.setState({ [e.target.id]: e.target.value });
    } else {
      alert("Only Numbers Allowed");
      return;
      //   this.setState({ [e.target.id]: e.target.value.slice(0, -1) });
    }
  };
  const changeHandler = (e) => {
    //;
    if (e.target.type === "checkbox") {
      e.target.id === "isThemeBased" && setisThemeBased(!e.target.checked);
      e.target.id === "showExpertDoctorsList" &&
        setshowExpertDoctorsList(!e.target.checked);
      e.target.id === "showSpecializationList" &&
        setshowSpecializationList(!e.target.checked);
      e.target.id === "showDoctorTiming" &&
        setshowDoctorTiming(!e.target.checked);
      e.target.id === "isDoctorHomePageCalendar" &&
        setisDoctorHomePageCalendar(!e.target.checked);
      e.target.id === "hasHealthTracker" &&
        sethasHealthTracker(!e.target.checked);
      e.target.id === "hasServices" && sethasServices(!e.target.checked);
      e.target.id === "hasPatientLogin" &&
        sethasPatientLogin(!e.target.checked);
      e.target.id === "hasChat" && sethasChat(!e.target.checked);
      e.target.id === "isNetworkEnabled" &&
        setisNetworkEnabled(!e.target.checked);
      e.target.id === "prNumberEnabled" &&
        setprNumberEnabled(!e.target.checked);
      e.target.id === "isParent" && setisParent(!e.target.checked);

      //   this.setState({ [e.target.id]: !e.target.checked });
    } else {
      e.target.id === "name" && setname(e.target.value);
      e.target.id === "themeId" && setthemeId(e.target.value);
      e.target.id === "emrStatus" && setemrStatus(e.target.value);
      e.target.id === "parentSiteId" && setparentSiteId(e.target.value);
      e.target.id === "emailPassword" && setemailPassword(e.target.value);
      e.target.id === "groupEmailId" && setgroupEmailId(e.target.value);
      e.target.id === "googleSiteAnalytics" &&
        setgoogleSiteAnalytics(e.target.value);
      e.target.id === "innerHtml" && setinnerHtml(e.target.value);
      e.target.id === "dashboardHtml" && setdashboardHtml(e.target.value);
      e.target.id === "registraionTerms" && setregistraionTerms(e.target.value);
      e.target.id === "pulseRegistraionTerms" &&
        setpulseRegistraionTerms(e.target.value);
      e.target.id === "emailConsultTerms" &&
        setemailConsultTerms(e.target.value);
      e.target.id === "videoChatTerms" && setvideoChatTerms(e.target.value);
      e.target.id === "bookAppointmentTerms" &&
        setbookAppointmentTerms(e.target.value);
      e.target.id === "welcomeText" && setwelcomeText(e.target.value);
      e.target.id === "registrationMailText" &&
        setregistrationMailText(e.target.value);
      e.target.id === "seoDescription" && setseoDescription(e.target.value);
      e.target.id === "privacyPolicy" && setprivacyPolicy(e.target.value);
      e.target.id === "termsAndCondition" &&
        settermsAndCondition(e.target.value);
      e.target.id === "doctorAppPrivacyPolicy" &&
        setdoctorAppPrivacyPolicy(e.target.value);
      e.target.id === "doctorAppTermsAndCondition" &&
        setdoctorAppTermsAndCondition(e.target.value);
      e.target.id === "seoTitle" && setseoTitle(e.target.value);
      e.target.id === "seoKeywords" && setseoKeywords(e.target.value);
      e.target.id === "slug" && setslug(e.target.value);
      e.target.id === "pulseSlug" && setpulseSlug(e.target.value);
      e.target.id === "pulseTitle" && setpulseTitle(e.target.value);
      e.target.id === "address" && setaddress(e.target.value);
      e.target.id === "hospitalWorkingTime" &&
        sethospitalWorkingTime(e.target.value);
      e.target.id === "patientDashBoard" && setpatientDashBoard(e.target.value);
      e.target.id === "advertisementScript" &&
        setadvertisementScript(e.target.value);
      e.target.id === "enabled" && setenabled(e.target.value);
      //   this.setState({ [e.target.id]: e.target.value });
    }
    if (e.target.id === "name") {
      setpulseNameData(e.target.value);
      setseoTitle(e.target.value);
      setdisplayName(e.target.value);
    }
    if (e.target.id === "commission") {
      const re = /(\d+(?:\.\d+)?)/;
      if (e.target.value === "" || re.test(e.target.value)) {
        e.target.name === "videoChatCommission" &&
          setvideoChatCommission(e.target.value);
        e.target.name === "audioChatCommission" &&
          setaudioChatCommission(e.target.value);
        e.target.name === "textChatCommission" &&
          settextChatCommission(e.target.value);
        // this.setState({ [e.target.name]: e.target.value });
      }
    }
    if (e.target.type === "text") {
      //   e.target.id === "name" && setname(e.target.value);
      e.target.id === "siteUrl" && setsiteUrl(e.target.value);
      e.target.id === "projectName" && setprojectName(e.target.value);
      e.target.id === "doctorRegistrationCount" &&
        setdoctorRegistrationCount(e.target.value);
      e.target.id === "fbPixel" && setfbPixel(e.target.value);
      e.target.id === "price" && setprice(e.target.value);
      e.target.id === "contactNo" && setcontactNo(e.target.value);
      e.target.id === "siteEmailId" && setsiteEmailId(e.target.value);
      e.target.id === "sessionTimeOutUrl" &&
        setsessionTimeOutUrl(e.target.value);
      e.target.id === "grievancesEmailId" &&
        setgrievancesEmailId(e.target.value);
      e.target.id === "awsEndPoint" && setawsEndPoint(e.target.value);
      e.target.id === "awsRegion" && setawsRegion(e.target.value);
      e.target.id === "userRegisterMode" && setuserRegisterMode(e.target.value);
      e.target.id === "myyShoppGroupId" && setmyyShoppGroupId(e.target.value);
      e.target.id === "chatCode" && setchatCode(e.target.value);
      e.target.id === "adminEmailId" && setadminEmailId(e.target.value);
      e.target.id === "adminContactNo" && setadminContactNo(e.target.value);
      e.target.id === "inPersonAppointmentTimeInterval" &&
        setinPersonAppointmentTimeInterval(e.target.value);
      e.target.id === "videoAppointmentTimeInterval" &&
        setvideoAppointmentTimeInterval(e.target.value);
      e.target.id === "callADoctorTimeInterval" &&
        setcallADoctorTimeInterval(e.target.value);
      e.target.id === "pulseNameData" && setpulseNameData(e.target.value);
      e.target.id === "pulseSiteUrl" && setpulseSiteUrl(e.target.value);
      e.target.id === "pulseSessionTimeOutUrl" &&
        setpulseSessionTimeOutUrl(e.target.value);
      e.target.id === "smsSenderId" && setsmsSenderId(e.target.value);
      e.target.id === "smsGatewayEntityId" &&
        setsmsGatewayEntityId(e.target.value);
      e.target.id === "emailHost" && setemailHost(e.target.value);
      e.target.id === "emailUserId" && setemailUserId(e.target.value);
      e.target.id === "emailPort" && setemailPort(e.target.value);
      e.target.id === "totalTransactionalSmsCount" &&
        settotalTransactionalSmsCount(e.target.value);
      e.target.id === "totalPromotionalSmsCount" &&
        settotalPromotionalSmsCount(e.target.value);
      e.target.id === "availTransactionalSmsCount" &&
        setavailTransactionalSmsCount(e.target.value);
      e.target.id === "availPromotionalSmsCount" &&
        setavailPromotionalSmsCount(e.target.value);
      e.target.id === "userTitle" && setuserTitle(e.target.value);
      e.target.id === "displayName" && setdisplayName(e.target.value);
      e.target.id === "mobileNumber" && setmobileNumber(e.target.value);
      //   this.setState({ [e.target.id]: e.target.value });
    }
    if (e.target.id === "contactNo") {
      var previousValue = contactNo;
      let pattern = /^[0-9]{0,10}$/;
      var newValue = e.target.value;
      if (pattern.test(newValue)) {
        setcontactNo(newValue);
      } else {
        alert("Only 10-digit Numbers Allowed");
        setcontactNo(previousValue);
      }
    }
  };
  const getSiteDetails = () => {
    let bucketPath =
      imagePathData.s3BucketRelianceAddressPath +
      "/" +
      imagePathData.S3BucketMainFolder +
      "/" +
      imagePathData.pulseLogoPath +
      "/";
    $(".loader").show();
    const addOrEditSite = {
      method: "POST",
      body: JSON.stringify({
        functionName: "editSiteSettings",
        siteId: siteId,
      }),
    };
    apiCalling(addOrEditSite).then(async (data) => {
      if (data.success === "1") {
        var siteData = data.siteData[0];
        setdoctorDataList(data.doctorData);
        setname(siteData.name);
        sethospitalData(data.hospitalData);
        setpulseSiteUrl(siteData.pulseSiteUrl.replace("xx", siteData.siteId));
        // ;
        setcontactNo(siteData.contactNo);
        setemailPort(siteData.emailPort);
        setsiteUrl(siteData.siteUrl.replace("xx", siteData.siteId));
        setlogoPath(bucketPath + siteData.logoPath);
        setfavIcon(bucketPath + "favicon/" + siteData.favIcon);
        setgoogleSiteAnalytics(siteData.googleSiteAnalytics);
        setawsEndPoint(siteData.awsEndPoint);
        setthemeId(siteData.themeId);
        setgroupEmailId(siteData.groupEmailId);
        setmyyShoppGroupId(siteData.myyShoppGroupId);
        setfbPixel(siteData.fbPixel);
        setparentSiteId(siteData.parentSiteId);
        setappLogoUrl(
          siteData.appLogoUrl === "" ? upload : bucketPath + siteData.appLogoUrl
        );
        setprice(siteData.price);
        setprojectName(siteData.projectName);
        setgrievancesEmailId(siteData.grievancesEmailId);
        setemailHost(siteData.emailHost);
        setmobileNumber(siteData.mobileNumber);
        setisParent(siteData.isParent);
        setinPersonAppointmentTimeInterval(
          siteData.inPersonAppointmentTimeInterval
        );
        setsmsGatewayEntityId(siteData.smsGatewayEntityId);
        setappWelcomeScreenImageUrl(
          siteData.appWelcomeScreenImageUrl === ""
            ? upload
            : bucketPath + siteData.appWelcomeScreenImageUrl
        );
        setemailUserId(siteData.emailUserId);
        setloginBackgroundUrl(
          siteData.loginBackgroundUrl === ""
            ? upload
            : bucketPath + siteData.loginBackgroundUrl
        );
        setshowExpertDoctorsList(siteData.showExpertDoctorsList);
        sethasServices(
          siteData["hasServices"] === "" ? false : siteData["hasServices"]
        );
        setshowSpecializationList(siteData.showSpecializationList);
        setsmsGatewayId(siteData.smsGatewayId);
        sethasChat(siteData["hasChat"] === "" ? false : siteData["hasChat"]);
        setisNetworkEnabled(
          siteData["isNetworkEnabled"] === ""
            ? false
            : siteData["isNetworkEnabled"]
        );
        setpulseNameData(
          siteData["pulseNameData"] === "" ? false : siteData["pulseNameData"]
        );
        setprNumberEnabled(
          siteData["prNumberEnabled"] === ""
            ? false
            : siteData["prNumberEnabled"]
        );
        setemrStatus(
          siteData["emrStatus"] === "" ? false : siteData["emrStatus"]
        );
        setvideoChatCommission(
          siteData["videoChatCommission"] === ""
            ? ""
            : siteData["videoChatCommission"]
        );
        setaudioChatCommission(
          siteData["audioChatCommission"] === ""
            ? ""
            : siteData["audioChatCommission"]
        );
        settextChatCommission(
          siteData["textChatCommission"] === ""
            ? ""
            : siteData["textChatCommission"]
        );
        setpulseSiteUrl(
          siteData["pulseSiteUrl"] === "" ? "" : siteData["pulseSiteUrl"]
        );
        setchatCode(siteData["chatCode"] === "" ? "" : siteData["chatCode"]);
        setpulseSlug(siteData["pulseSlug"] === "" ? "" : siteData["pulseSlug"]);
        sethasPatientLogin(
          siteData["hasPatientLogin"] === ""
            ? false
            : siteData["hasPatientLogin"]
        );
        sethasHealthTracker(
          siteData["hasHealthTracker"] === ""
            ? false
            : siteData["hasHealthTracker"]
        );
        setenabled(siteData["enabled"] === "" ? false : siteData["enabled"]);
        setsiteEmailId(siteData.siteEmailId);
        setadvertisementScript(siteData.advertisementScript);
        setvideoAppointmentTimeInterval(siteData.videoAppointmentTimeInterval);
        setpromotionalSmsValidFrom(siteData.promotionalSmsValidFrom);
        setpromotionalSmsValidTo(siteData.promotionalSmsValidTo);
        settransactionalSmsValidFrom(siteData.transactionalSmsValidFrom);
        settransactionalSmsValidTo(siteData.transactionalSmsValidTo);
        setdoctorRegistrationCount(siteData.doctorRegistrationCount);
        setshowDoctorTiming(siteData.showDoctorTiming);
        setuserTitle(siteData.userTitle);
        setuserRegisterMode(siteData.userRegisterMode);
        setawsRegion(siteData.awsRegion);
        setsessionTimeOutUrl(siteData.sessionTimeOutUrl);
        setpulseSessionTimeOutUrl(siteData.pulseSessionTimeOutUrl);
        setavailPromotionalSmsCount(siteData.availPromotionalSmsCount);
        setavailTransactionalSmsCount(siteData.availTransactionalSmsCount);
        settotalTransactionalSmsCount(siteData.totalTransactionalSmsCount);
        settotalPromotionalSmsCount(siteData.totalPromotionalSmsCount);
        setadminEmailId(siteData.adminEmailId);
        setadminContactNo(siteData.adminContactNo);
        setisActive(siteData["isActive"] === "" ? false : siteData["isActive"]);
        setisidalogin(
          siteData["isidalogin"] === "" ? false : siteData["isidalogin"]
        );
        setisThemeBased(
          siteData["isThemeBased"] === "" ? false : siteData["isThemeBased"]
        );
        setpatientDashBoard(
          siteData["patientDashBoard"] == ""
            ? ""
            : siteData["patientDashBoard"].replaceAll("''", "'")
        );
        setdoctorAppTermsAndCondition(
          siteData["doctorAppTermsAndCondition"] === ""
            ? ""
            : siteData["doctorAppTermsAndCondition"].replaceAll("''", "'")
        );

        setdoctorAppPrivacyPolicy(
          siteData["doctorAppPrivacyPolicy"] === ""
            ? ""
            : siteData["doctorAppPrivacyPolicy"].replaceAll("''", "'")
        );
        setprivacyPolicy(
          siteData["privacyPolicy"] === ""
            ? ""
            : siteData["privacyPolicy"].replaceAll("''", "'")
        );
        settermsAndCondition(
          siteData["termsAndCondition"] === ""
            ? ""
            : siteData["termsAndCondition"].replaceAll("''", "'")
        );
        ///////////////////////////////////////////////////////////////////////
        if (
          siteData["innerHtml"] !== "" &&
          !siteData["innerHtml"].includes("div")
        ) {
          setinnerHtml(
            await axios
              .get(siteData["innerHtml"])
              .then((response) => {
                return response.data.replaceAll("''", "'");
              })
              .catch((error) => {
                console.log(error);
              })
          );
        } else if (
          siteData["innerHtml"] !== "" &&
          siteData["innerHtml"].includes("div")
        ) {
          setinnerHtml(siteData["innerHtml"].replaceAll("''", "'"));
        } else {
          setinnerHtml("");
        }
        ////////////////////////////////////////////
        if (
          siteData["dashboardHtml"] !== "" &&
          !siteData["dashboardHtml"].includes("div")
        ) {
          setdashboardHtml(
            await axios
              .get(siteData["dashboardHtml"])
              .then((response) => {
                return response.data.replaceAll("''", "'");
              })
              .catch((error) => {
                console.log(error);
              })
          );
        } else if (
          siteData["dashboardHtml"] !== "" &&
          siteData["dashboardHtml"].includes("div")
        ) {
          setdashboardHtml(siteData["dashboardHtml"].replaceAll("''", "'"));
        } else {
          setdashboardHtml("");
          siteData["dashboardHtml"] = "";
        }
        /////////////////////////////////////////////
        setregistraionTerms(
          siteData["registraionTerms"] == ""
            ? ""
            : siteData["registraionTerms"].replaceAll("''", "'")
        );
        setpulseRegistraionTerms(
          siteData["pulseRegistraionTerms"] == ""
            ? ""
            : siteData["pulseRegistraionTerms"].replaceAll("''", "'")
        );
        setemailConsultTerms(
          siteData["emailConsultTerms"] == ""
            ? ""
            : siteData["emailConsultTerms"].replaceAll("''", "'")
        );
        setvideoChatTerms(
          siteData["videoChatTerms"] == ""
            ? ""
            : siteData["videoChatTerms"].replaceAll("''", "'")
        );
        setemailPassword(siteData.emailPassword);
        setbookAppointmentTerms(
          siteData["bookAppointmentTerms"] == ""
            ? ""
            : siteData["bookAppointmentTerms"].replaceAll("''", "'")
        );
        setwelcomeText(
          siteData["welcomeText"] == ""
            ? ""
            : siteData["welcomeText"].replaceAll("''", "'")
        );
        setregistrationMailText(
          siteData["registrationMailText"] == ""
            ? ""
            : siteData["registrationMailText"].replaceAll("''", "'")
        );
        setseoDescription(
          siteData["seoDescription"] == ""
            ? ""
            : siteData["seoDescription"].replaceAll("''", "'")
        );
        setseoTitle(
          siteData["seoTitle"] == ""
            ? ""
            : siteData["seoTitle"].replaceAll("''", "'")
        );
        setseoKeywords(
          siteData["seoKeywords"] == ""
            ? ""
            : siteData["seoKeywords"].replaceAll("''", "'")
        );
        setslug(
          siteData["slug"] == "" ? "" : siteData["slug"].replaceAll("''", "'")
        );
        setpulseTitle(
          siteData["pulseTitle"] == ""
            ? ""
            : siteData["pulseTitle"].replaceAll("''", "'")
        );
        setsmsSenderId(
          siteData["smsSenderId"] == ""
            ? ""
            : siteData["smsSenderId"].replaceAll("''", "'")
        );
        sethospitalWorkingTime(
          siteData["hospitalWorkingTime"] == ""
            ? ""
            : siteData["hospitalWorkingTime"].replaceAll("''", "'")
        );

        setaddress(
          siteData["address"] == ""
            ? ""
            : siteData["address"].replaceAll("''", "'")
        );
        setdisplayName(
          siteData["displayName"] == ""
            ? ""
            : siteData["displayName"].replaceAll("''", "'")
        );
        setisDoctorHomePageCalendar(
          siteData["isDoctorHomePageCalendar"] === ""
            ? false
            : siteData["isDoctorHomePageCalendar"]
        );

        let hospitalId;
        let hospitalIdsState = [];
        for (let i = 0; i < hospitalData.length; i++) {
          hospitalId = hospitalData[i].hospitalId;
          hospitalIdsState.push(hospitalId);
          // sethospitalIdsList([...hospitalIdsList, hospitalId]);
          // this.setState({
          //   hospitalIdsList: [...hospitalIdsList, hospitalId],
          // });
        }
        sethospitalIdsList(hospitalIdsState);
        setstringHospitalIds(hospitalIdsState.toString());
        // this.setState({
        //   stringHospitalIds: hospitalIdsList.toString(),
        // });
        // this.setState(siteData, () => {
        //   $(".loader").hide();
        // });
      } else {
        $(".loader").hide();
      }
    });
  };
  const handleHospitalAutoFill = (e) => {
    settempHospitalData(e);
  };
  const handleDoctorAutoFill = (e) => {
    settempDoctorData(e);
  };
  const handleAddHospital = () => {
    // let

    let index = hospitalData.findIndex(
      (x) => x.hospitalId === tempHospitalData.hospitalId
    );
    let hospitalDataTemp = hospitalData;
    if (tempHospitalData.hospitalId !== "" && index < 0) {
      hospitalDataTemp.push(tempHospitalData);
    }
    let hospitalIdData = hospitalIdsList;
    if (tempHospitalData.hospitalId !== "" && index < 0) {
      hospitalIdData.push(tempHospitalData.hospitalId);
    }
    sethospitalData(hospitalDataTemp);
    setstringHospitalIds(hospitalIdData.toString());
    settempHospitalData({
      hospitalId: "",
      hospitalName: "",
    });
  };
  const handleCancelHospital = (id) => {
    let hospitalDataTemp = hospitalData.filter((e) => e.hospitalId !== id);
    removeHospitalIdsArray.push(id);
    sethospitalData(hospitalDataTemp);
    let hospitalIdsListTemp = hospitalIdsList.filter((e) => e !== id);
    sethospitalIdsList(hospitalIdsListTemp);
    setstringHospitalIds(hospitalIdsList.toString());
  };
  const handleCancelDoctor = (id) => {
    let doctorDataListTemp = doctorDataList.filter((e) => e.doctorId !== id);
    removeDoctorIdsArray.push(id);
    setdoctorDataList(doctorDataListTemp);
    // this.setState({ doctorDataList });
  };
  const handleAddDoctor = () => {
    let index = doctorDataList.findIndex(
      (x) => x.doctorId === tempDoctorData.doctorId
    );
    let doctorDataListTemp = doctorDataList;
    if (tempDoctorData.doctorId > 0 && index < 0) {
      doctorDataListTemp.push(tempDoctorData);
    }
    setdoctorDataList(doctorDataListTemp);
    settempDoctorData({
      doctorId: 0,
      doctorName: "",
    });
  };
  const handleHospitalSearch = (tempHospitalData) => {
    settempHospitalData(tempHospitalData);
    // ;
    // this.setState({
    //   tempHospitalData,
    // });
  };
  const handleDoctorSearch = (e) => {
    settempDoctorData({
      doctorId: 0,
      doctorName: e,
    });
  };
  const validateForm = () => {
    let hospitalList = hospitalData.map((hospital) => hospital.hospitalId);
    let contactTest = /[0-9]{10}/;
    let contactEmailId = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$/i; //?Not Case Sensitive
    if (name === "") {
      setTimeout(() => {
        $("#name").focus();
      }, 20);
      alert("Site Name required.");
    } else if (siteUrl === "") {
      setTimeout(() => {
        $("#siteUrl").focus();
      }, 20);
      alert("Site Url required.");
      return false;
    } else if (themeId === "") {
      setTimeout(() => {
        $("#themeId").focus();
      }, 20);
      alert("Theme required.");
      return false;
    } else if (!contactTest.test(contactNo)) {
      setTimeout(() => {
        $("#contactNo").focus();
      }, 20);
      alert("Contact Number must have 10 Digits");
      return false;
    } else if (siteEmailId === "") {
      setTimeout(() => {
        $("#siteEmailId").focus();
      }, 20);
      alert("Contact Email Id required.");
      return false;
    } else if (!contactEmailId.test(siteEmailId)) {
      setTimeout(() => {
        $("#siteEmailId").focus();
      }, 20);
      alert("invalid Contact Email Id.");
      return false;
    } else if (!contactEmailId.test(emailUserId)) {
      setTimeout(() => {
        $("#emailUserId").focus();
      }, 20);
      alert("invalid Email User Id.");
      return false;
    } else if (displayName === "") {
      setTimeout(() => {
        $("#displayName").focus();
      }, 20);
      alert("Display Name required.");
      return false;
    } else if (mobileNumber === "") {
      setTimeout(() => {
        $("#mobileNumber").focus();
      }, 20);
      alert("Mobile Number Name required.");
      return false;
    } else if (!contactEmailId.test(groupEmailId)) {
      setTimeout(() => {
        $("#groupEmailId").focus();
      }, 20);
      alert("Invalid Group Email Id");
      return false;
    } else if (isThemeBased && themeId === "") {
      setTimeout(() => {
        $("#themeId").focus();
      }, 20);
      alert("Theme required.");
      return false;
    } else if (
      adminContactNo !== "" &&
      !contactTest.test(parseInt(adminContactNo))
    ) {
      alert("Only 10 Digit Numbers Allowed");
      setTimeout(() => {
        $("#adminContactNo").focus();
      }, 10);
      return false;
    } else {
      return true;
    }
  };
  const disableDateField = (event, id) => {
    // event.preventDefault();
    //return false;
  };
  const saveSite = async (e, locationInnerHtml, locationDashBoardHtml) => {
    e.preventDefault(); //! to prevent page refresh
    if (validateForm()) {
      // ;
      // let siteSettingData = this.state;
      let siteSettingData = {
        tempFunctionName: "siteSettings",
      };
      let contactNoTemp = Number(contactNo);
      let hospitalList = hospitalData.map((hospital) => hospital.hospitalId);
      let cancelList = removeHospitalIdsArray.toString();
      let cancelDoctorList = removeDoctorIdsArray.toString();
      let doctorList = doctorDataList.map((doctor) => doctor.doctorId);
      let nameTemp = stringreplacenpm(name.trim());
      let patientDashBoardTemp = stringreplacenpm(patientDashBoard);
      let doctorAppTermsAndConditionTemp = stringreplacenpm(
        doctorAppTermsAndCondition
      );
      let doctorAppPrivacyPolicyTemp = stringreplacenpm(doctorAppPrivacyPolicy);
      let patientAppPrivacyPolicyTemp = stringreplacenpm(privacyPolicy);
      let termsAndConditionTemp = stringreplacenpm(termsAndCondition);
      let pulseHomePageTemp = locationInnerHtml;
      let pulseHospitalAdminDashboardTemp = locationDashBoardHtml;
      // stringreplacenpm(
      //   dashboardHtml
      // );
      let registraionTermsTemp = stringreplacenpm(registraionTerms);
      let pulseRegistraionTermsTemp = stringreplacenpm(pulseRegistraionTerms);
      let emailConsultTermsTemp = stringreplacenpm(emailConsultTerms);
      let videoChatTermsTemp = stringreplacenpm(videoChatTerms);
      let bookAppointmentTermsTemp = stringreplacenpm(bookAppointmentTerms);
      let welcomeTextTemp = stringreplacenpm(welcomeText);
      let registrationMailTextTemp = stringreplacenpm(registrationMailText);
      let seoDescriptionTemp = stringreplacenpm(seoDescription);
      let seoTitleTemp = stringreplacenpm(seoTitle);
      let seoKeywordsTemp = stringreplacenpm(seoKeywords);
      let slugTemp = stringreplacenpm(slug);
      let pulseTitleTemp = stringreplacenpm(pulseTitle);
      let projectNameTemp = stringreplacenpm(projectName);
      let hospitalWorkingTimeTemp = stringreplacenpm(hospitalWorkingTime);
      hospitalWorkingTimeTemp = hospitalWorkingTime.replaceAll("\n", " ");
      let addressTemp = stringreplacenpm(address);
      let displayNameTemp = stringreplacenpm(displayName);
      let pulseSlugTemp = stringreplacenpm(pulseSlug);
      let pulseNameDataTemp = stringreplacenpm(pulseNameData);
      let googleSiteAnalyticsTemp = stringreplacenpm(googleSiteAnalytics);
      let advertisementScriptTemp = stringreplacenpm(advertisementScript);
      let siteEmailIdTemp = stringreplacenpm(siteEmailId);
      let emailHostTemp = stringreplacenpm(emailHost);
      let pulseSessionTimeOutUrlTemp = stringreplacenpm(pulseSessionTimeOutUrl);
      siteSettingData["functionName"] = "saveSiteSettings";
      siteSettingData["hospitalList"] = hospitalList;
      siteSettingData["doctorList"] = doctorList;
      siteSettingData["siteId"] = siteId;
      siteSettingData["groupEmailId"] = groupEmailId;
      siteSettingData["themeId"] = themeId;
      siteSettingData["groupHospitalAdminId"] = groupHospitalAdminId;
      siteSettingData["name"] = nameTemp;
      siteSettingData["userTitle"] = userTitle;
      siteSettingData["inPersonAppointmentTimeInterval"] =
        inPersonAppointmentTimeInterval;
      siteSettingData["videoAppointmentTimeInterval"] =
        videoAppointmentTimeInterval;
      siteSettingData["callADoctorTimeInterval"] = callADoctorTimeInterval;
      siteSettingData["emailPassword"] = emailPassword;
      siteSettingData["awsEndPoint"] = awsEndPoint;
      siteSettingData["awsRegion"] = awsRegion;
      siteSettingData["isNetworkEnabled"] = isNetworkEnabled;
      siteSettingData["doctorAppTermsAndCondition"] =
        doctorAppTermsAndConditionTemp.toString();
      siteSettingData["doctorAppPrivacyPolicy"] =
        doctorAppPrivacyPolicyTemp.toString();
      siteSettingData["privacyPolicy"] = patientAppPrivacyPolicyTemp.toString();
      siteSettingData["googleSiteAnalytics"] =
        googleSiteAnalyticsTemp.toString();
      siteSettingData["projectName"] = projectNameTemp;
      siteSettingData["isDoctorHomePageCalendar"] = isDoctorHomePageCalendar;
      siteSettingData["parentSiteId"] = parentSiteId;
      siteSettingData["hasServices"] = hasServices;
      siteSettingData["termsAndCondition"] = termsAndConditionTemp.toString();
      siteSettingData["advertisementScript"] =
        advertisementScriptTemp.toString();
      siteSettingData["innerHtml"] = pulseHomePageTemp.toString();
      siteSettingData["pulseNameData"] = pulseNameDataTemp.toString();
      siteSettingData["myyShoppGroupId"] = myyShoppGroupId.toString();
      siteSettingData["isParent"] = isParent.toString();
      siteSettingData["dashboardHtml"] =
        pulseHospitalAdminDashboardTemp.toString();
      siteSettingData["registraionTerms"] = registraionTermsTemp.toString();
      siteSettingData["pulseRegistraionTerms"] =
        pulseRegistraionTermsTemp.toString();
      siteSettingData["emailConsultTerms"] = emailConsultTermsTemp.toString();
      siteSettingData["pulseSiteUrl"] = pulseSiteUrl.toString();
      siteSettingData["siteUrl"] = siteUrl.toString();
      siteSettingData["videoChatTerms"] = videoChatTermsTemp.toString();
      siteSettingData["bookAppointmentTerms"] =
        bookAppointmentTermsTemp.toString();
      siteSettingData["welcomeText"] = welcomeTextTemp.toString();
      siteSettingData["registrationMailText"] =
        registrationMailTextTemp.toString();
      siteSettingData["seoDescription"] = seoDescriptionTemp.toString();
      siteSettingData["groupPassword"] = groupPassword.toString();
      siteSettingData["seoTitle"] = seoTitleTemp.toString();
      siteSettingData["seoKeywords"] = seoKeywordsTemp.toString();
      siteSettingData["slug"] = slugTemp.toString();
      siteSettingData["pulseTitle"] = pulseTitleTemp.toString();
      siteSettingData["address"] = addressTemp.toString();
      siteSettingData["siteEmailId"] = siteEmailIdTemp.toString();
      siteSettingData["hospitalWorkingTime"] = hospitalWorkingTimeTemp;
      siteSettingData["patientDashBoard"] = patientDashBoardTemp;
      siteSettingData["displayName"] = displayNameTemp.toString();
      siteSettingData["removeHospitalIds"] = cancelList;
      siteSettingData["removeDoctorIds"] = cancelDoctorList;
      siteSettingData["pulseSlug"] = pulseSlugTemp;
      siteSettingData["price"] = price;
      siteSettingData["contactNo"] = contactNoTemp;
      siteSettingData["emailHost"] = emailHostTemp;
      siteSettingData["showExpertDoctorsList"] = showExpertDoctorsList;
      siteSettingData["sessionTimeOutUrl"] = sessionTimeOutUrl;
      siteSettingData["showSpecializationList"] = showSpecializationList;
      siteSettingData["emailPort"] = emailPort;
      siteSettingData["smsSenderId"] = smsSenderId;
      siteSettingData["emailUserId"] = emailUserId;
      siteSettingData["hasChat"] = hasChat;
      siteSettingData["prNumberEnabled"] = prNumberEnabled;
      siteSettingData["chatCode"] = chatCode;
      siteSettingData["emrStatus"] = emrStatus;
      siteSettingData["mobileNumber"] = mobileNumber;
      siteSettingData["enabled"] = Boolean(enabled);
      siteSettingData["isThemeBased"] = isThemeBased;
      siteSettingData["hasPatientLogin"] = hasPatientLogin;
      siteSettingData["showDoctorTiming"] = showDoctorTiming;
      siteSettingData["promotionalSmsValidFrom"] = promotionalSmsValidFrom;
      siteSettingData["promotionalSmsValidTo"] = promotionalSmsValidTo;
      siteSettingData["transactionalSmsValidFrom"] = transactionalSmsValidFrom;
      siteSettingData["transactionalSmsValidTo"] = transactionalSmsValidTo;
      siteSettingData["hasHealthTracker"] = hasHealthTracker;
      siteSettingData["videoChatCommission"] = videoChatCommission;
      siteSettingData["audioChatCommission"] = audioChatCommission;
      siteSettingData["textChatCommission"] = textChatCommission;
      siteSettingData["fbPixel"] = fbPixel;
      siteSettingData["adminEmailId"] = adminEmailId;
      siteSettingData["contactNo"] = contactNo;
      siteSettingData["smsGatewayId"] = smsGatewayId;
      siteSettingData["smsGatewayEntityId"] = smsGatewayEntityId;
      siteSettingData["pulseSessionTimeOutUrl"] = pulseSessionTimeOutUrlTemp;
      delete siteSettingData["removeDoctorIdsArray"];
      delete siteSettingData["remove"];
      delete siteSettingData["doctorDataList"];
      delete siteSettingData["AWSAccessKeyId"];
      delete siteSettingData["hospitalData"];
      delete siteSettingData["themeData"];
      delete siteSettingData["tempHospitalData"];
      delete siteSettingData["tempDoctorData"];
      delete siteSettingData["themeName"];
      let arrLogoPath = logoPath.split("/");
      let arrFavIcon = favIcon.split("/");
      let arrAppLogoUrl = appLogoUrl.split("/");
      let arrAppWelcomeScreenImageUrl = appWelcomeScreenImageUrl.split("/");
      let arrLoginBackgroundUrl = loginBackgroundUrl.split("/");
      let adminContactNoTemp = adminContactNo == "" ? adminContactNo : "";
      let re = /([0-9]{10})/;
      let number = adminContactNoTemp;
      if (logoPath === "" || arrLogoPath[arrLogoPath.length - 1] === "") {
        siteSettingData["logoPath"] = "Default-logos.png";
      } else {
        siteSettingData["logoPath"] = arrLogoPath[arrLogoPath.length - 1];
      }
      if (favIcon === "" || arrFavIcon[arrFavIcon.length - 1] === "") {
        siteSettingData["favIcon"] = "Default-fav_icon.ico";
      } else {
        siteSettingData["favIcon"] = arrFavIcon[arrFavIcon.length - 1];
      }
      siteSettingData["adminContactNo"] = number;
      siteSettingData["appLogoUrl"] = arrAppLogoUrl[arrAppLogoUrl.length - 1];
      siteSettingData["appWelcomeScreenImageUrl"] =
        arrAppWelcomeScreenImageUrl[arrAppWelcomeScreenImageUrl.length - 1];
      siteSettingData["loginBackgroundUrl"] =
        arrLoginBackgroundUrl[arrLoginBackgroundUrl.length - 1];
      siteSettingData["userRegisterMode"] =
        userRegisterMode === "" ? "0" : userRegisterMode;
      siteSettingData["doctorRegistrationCount"] =
        doctorRegistrationCount === "" ? "0" : doctorRegistrationCount;
      siteSettingData["availPromotionalSmsCount"] =
        availPromotionalSmsCount === "" ? "0" : availPromotionalSmsCount;
      siteSettingData["availTransactionalSmsCount"] =
        availTransactionalSmsCount === "" ? "0" : availTransactionalSmsCount;
      siteSettingData["totalPromotionalSmsCount"] =
        totalPromotionalSmsCount === "" ? "0" : totalPromotionalSmsCount;
      siteSettingData["totalTransactionalSmsCount"] =
        totalTransactionalSmsCount === "" ? "0" : totalTransactionalSmsCount;
      const saveSiteSettings = {
        method: "POST",
        body: JSON.stringify(siteSettingData),
      };

      // return false
      //!...........................................................
      var res = await awsAPIUrlcommon(saveSiteSettings).then((data) => {
        // ;
        if (data.success === "1") {
          alert(data.successMessage);
        } else {
          alert(data.errorMessage);
        }
        changeMode("list", navigation, 0, "Add/Edit Site");
        $(".loader").hide();
      });
      //!...........................................................
    } else {
      $(".loader").hide();
    }
  };
  const changePass = () => {
    if (newPassword === "") {
      alert("Enter password to be changed");
      return false;
    }
    $("#changePassPopup").show();
    $(".loader").show();
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "changePassword",
        userId: groupHospitalAdminId,
        siteId: "",
        role: "ROLE_ADMIN",
        bundleId: "",
        currentPassword: "",
        newPassword: newPassword,
      }),
    };
    apiCalling(apiJson).then((data) => {
      if (data.success === "1") {
        alert("Password Changed successfully");
        $("#changePassPopup").hide();
        $(".loader").hide();
      } else {
        alert("Something went wrong while changing password");
      }
    });
  };
  const addMetaData = () => {
    $("#metadataPopup").show();
  };
  const foldersinS3bucket = (e) => {
    $(".loader").show();
    ////////////////////////////////////////////////////////////////////////
    var today = new Date();
    if (innerHtml === "") foldersinS3bucketdashboardHtml(e, "");
    else {
      const htmlCode = innerHtml;
      const innerHtmlFileNAme =
        displayName.replace(/ /g, "_") + "_innerHtml.html";
      const blobinnerHtml = new Blob([htmlCode], { type: "text/html" });
      const formData = new File([blobinnerHtml], innerHtmlFileNAme, {
        type: "text/html",
      });
      const s3 = new AWS.S3({
        accessKeyId: s3bucketAccessKey,
        secretAccessKey: AWSAccessKeyId,
        region: region,
      });
      let Bucket = bucket + "/production/pulseHomePageHTML";
      let S3BucketMainFolder = "";
      let fullFilePath = S3BucketMainFolder;
      s3.upload(
        {
          Bucket: Bucket,
          Key: innerHtmlFileNAme,
          Body: formData,
          ACL: "public-read",
        },
        (err, data) => {
          if (err) {
            alert("There was an error uploading your File:", err.message);
            $(".loader").hide();
          } else if (data) {
            // saveSite(e,data.Location)
            foldersinS3bucketdashboardHtml(e, data.Location);
            // alert("llllllll")
            // this.setState({ [fileFor]: data.Location });
          }
          // $(".loader").hide();
        }
      );
    }

    //////////////////////////////////////////////////////////////////
  };
  const foldersinS3bucketdashboardHtml = (e, LocationinnerHtml) => {
    var today = new Date();
    const htmlCodedashboardHtml = dashboardHtml;
    if (dashboardHtml === "") saveSite(e, LocationinnerHtml, "");
    else {
      const dashboardHtmlFileNAme =
        displayName.replace(/ /g, "_") + "dashBoard.html";
      const blobdashboardHtml = new Blob([htmlCodedashboardHtml], {
        type: "text/html",
      });
      const formDatadashboardHtml = new File(
        [blobdashboardHtml],
        dashboardHtmlFileNAme,
        { type: "text/html" }
      );
      const s3dashboardHtml = new AWS.S3({
        accessKeyId: s3bucketAccessKey,
        secretAccessKey: AWSAccessKeyId,
        region: region,
      });
      let BucketdashboardHtml = bucket + "/production/pulseHomePageHTML";
      let S3BucketMainFolderdashboardHtml = "";
      let fullFilePathdashboardHtml = S3BucketMainFolderdashboardHtml;
      s3dashboardHtml.upload(
        {
          Bucket: BucketdashboardHtml,
          Key: dashboardHtmlFileNAme,
          Body: formDatadashboardHtml,
          ACL: "public-read",
        },
        (err, data) => {
          if (err) {
            $(".loader").hide();
            alert("There was an error uploading your File:", err.message);
          } else if (data) {
            saveSite(e, LocationinnerHtml, data.Location);
            // alert("llllllll")
            // this.setState({ [fileFor]: data.Location });
          }
          // $(".loader").hide();
        }
      );
    }
  };

  return (
    <div>
      <div className="smssetng-btn mb-4 mt-4">
        <a
          className="sitesetng-cancelbtn mx-1"
          onClick={() => changeMode("list", navigation, 0, "Add/Edit Site")}
        >
          Cancel
        </a>
        <a
          className="smssetng-svebtn smssetng-svebtn-padd"
          onClick={(e) => foldersinS3bucket(e)}
        >
          Save
        </a>
        {siteId > 0 && (
          <a
            className="smssetng-svebtn smssetng-svebtn-padd"
            onClick={(e) => addMetaData()}
          >
            Add MetaData
          </a>
        )}
      </div>
      {siteId > 0 && <AddMetaDataPopup siteId={siteId}></AddMetaDataPopup>}
      <div className="row doctr-wraper-border-addimge mb-3">
        <div className="row col-md-12 m-0">
          <h2 className="row-margin col-md-12 hspInfoSubhead-site ">
            General Site Settings
          </h2>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Site Name <span className="hspifoMantory">*</span>{" "}
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="name"
                value={name}
                onInput={(e) => changeHandler(e)}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Site ID</label>
            <div className="col-md-12">
              <input
                type="text"
                disabled
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={siteId}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Site URL <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="siteUrl"
                value={siteUrl}
                onInput={(e) => changeHandler(e)}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text-siteimg-mob">
              Logo
              {/* <span className="hspifoMantory">*</span> */}
            </label>
            <div className="col-md-12">
              <img
                onClick={() =>
                  document.getElementById("uploadLogoPath").click()
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = upload;
                }}
                src={logoPath === "" ? upload : logoPath}
                className="ml-2"
                width="100px"
                height="40px"
              ></img>
              <input
                type="file"
                style={{ display: "none" }}
                accept="image/png, image/gif, image/jpeg"
                id="uploadLogoPath"
                onChange={fileChange}
                fileFor="logoPath"
                className="hspInfofieldinput Infoinputwidthdoctr"
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text-siteimg-mob">
              Fav icon
              {/* <span className="hspifoMantory">*</span> */}
            </label>
            <div className="col-md-12">
              <img
                onClick={() => document.getElementById("uploadFavIcon").click()}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = upload;
                }}
                src={favIcon === "" ? upload : favIcon}
                className="ml-2"
                width="30px"
                height="30px"
              ></img>
              <input
                type="file"
                style={{ display: "none" }}
                // accept="image/png, image/gif, image/jpeg, image/ico"
                accept="image/*"
                id="uploadFavIcon"
                onChange={fileChange}
                fileFor="favIcon"
                subFolder="favicon"
                className="hspInfofieldinput Infoinputwidthdoctr"
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text-siteimg-mob">
              App Logo URL
            </label>
            <div className="col-md-12">
              <img
                onClick={() =>
                  document.getElementById("uploadAppLogoUrl").click()
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = upload;
                }}
                src={appLogoUrl === "" ? upload : appLogoUrl}
                className="ml-2"
                width="50px"
                height="50px"
              ></img>
              <input
                type="file"
                style={{ display: "none" }}
                accept="image/png, image/gif, image/jpeg"
                id="uploadAppLogoUrl"
                onChange={fileChange}
                fileFor="appLogoUrl"
                className="hspInfofieldinput Infoinputwidthdoctr"
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text-siteimg-mob">
              App Welcome Screen Image URL
            </label>
            <div className="col-md-12">
              <img
                onClick={() =>
                  document
                    .getElementById("uploadAppWelcomeScreenImageUrl")
                    .click()
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = upload;
                }}
                src={
                  appWelcomeScreenImageUrl === ""
                    ? upload
                    : appWelcomeScreenImageUrl
                }
                className="ml-2"
                width="50px"
                height="50px"
              ></img>
              <input
                type="file"
                style={{ display: "none" }}
                accept="image/png, image/gif, image/jpeg"
                id="uploadAppWelcomeScreenImageUrl"
                onChange={fileChange}
                fileFor="appWelcomeScreenImageUrl"
                className="hspInfofieldinput Infoinputwidthdoctr"
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text-siteimg-mob">
              Login Background URL
            </label>
            <div className="col-md-12">
              <img
                onClick={() =>
                  document.getElementById("uploadLoginBackgroundUrl").click()
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = upload;
                }}
                src={loginBackgroundUrl === "" ? upload : loginBackgroundUrl}
                className="ml-2"
                width="50px"
                height="50px"
              ></img>
              <input
                type="file"
                style={{ display: "none" }}
                accept="image/png, image/gif, image/jpeg"
                id="uploadLoginBackgroundUrl"
                onChange={fileChange}
                fileFor="loginBackgroundUrl"
                className="hspInfofieldinput Infoinputwidthdoctr"
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Is theme based</label>
              <input
                type="checkbox"
                className="m-2"
                checked={isThemeBased}
                onInput={(e) => changeHandler(e)}
                id="isThemeBased"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Theme<span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <select
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="themeId"
                value={themeId}
                onInput={(e) => changeHandler(e)}
              >
                <option value="">Select Theme</option>
                {themeData.map((t) => (
                  <option key={t.themeId} value={t.themeId}>
                    {t.displayName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Project Name</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="projectName"
                value={projectName}
                onInput={(e) => changeHandler(e)}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">EMR Status</label>
            <div className="col-md-12">
              <select
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="emrStatus"
                value={emrStatus}
                onInput={(e) => changeHandler(e)}
              >
                <option value="0">EMR Site</option>
                <option value="1">Referral Site</option>
                <option value="2">Both</option>
              </select>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Doctor Registration Count
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={doctorRegistrationCount}
                onInput={(e) => changeHandler(e)}
                id="doctorRegistrationCount"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Fb Pixel Id</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={fbPixel}
                onInput={(e) => changeHandler(e)}
                id="fbPixel"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Price</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={price}
                onChange={(e) => isNumber(e)}
                id="price"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Contact Phone Number</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={contactNo}
                onInput={(e) => changeHandler(e)}
                name="contactNo"
                id="contactNo"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Contact Email Id <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={siteEmailId}
                onInput={(e) => changeHandler(e)}
                id="siteEmailId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Session Time Out URL</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={sessionTimeOutUrl}
                onInput={(e) => changeHandler(e)}
                id="sessionTimeOutUrl"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Grivances Email ID</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={grievancesEmailId}
                onInput={(e) => changeHandler(e)}
                id="grievancesEmailId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">AWS End Point</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={awsEndPoint}
                onInput={(e) => changeHandler(e)}
                id="awsEndPoint"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">AWS Region</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={awsRegion}
                onInput={(e) => changeHandler(e)}
                id="awsRegion"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              User Registration Mode
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={userRegisterMode}
                onInput={(e) => changeHandler(e)}
                id="userRegisterMode"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Myyshopp Group ID</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={myyShoppGroupId}
                onInput={(e) => changeHandler(e)}
                id="myyShoppGroupId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">
                Show Expert Doctors List
              </label>
              <input
                type="checkbox"
                className="m-2"
                checked={showExpertDoctorsList}
                onInput={(e) => changeHandler(e)}
                id="showExpertDoctorsList"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">
                Show Specialization List
              </label>
              <input
                type="checkbox"
                className="m-2"
                checked={showSpecializationList}
                onInput={(e) => changeHandler(e)}
                id="showSpecializationList"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Show Doctor Timing</label>
              <input
                type="checkbox"
                className="m-2"
                checked={showDoctorTiming}
                onInput={(e) => changeHandler(e)}
                id="showDoctorTiming"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">
                Is Doctor Home Page Calender
              </label>
              <input
                type="checkbox"
                className="m-2"
                checked={isDoctorHomePageCalendar}
                onInput={(e) => changeHandler(e)}
                id="isDoctorHomePageCalendar"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Has Health Tracker</label>
              <input
                type="checkbox"
                className="m-2"
                checked={hasHealthTracker}
                onInput={(e) => changeHandler(e)}
                id="hasHealthTracker"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Has Service</label>
              <input
                type="checkbox"
                className="m-2"
                checked={hasServices}
                onInput={(e) => changeHandler(e)}
                id="hasServices"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Has Patient Login</label>
              <input
                type="checkbox"
                className="m-2"
                checked={hasPatientLogin}
                onInput={(e) => changeHandler(e)}
                id="hasPatientLogin"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Has Chat</label>
              <input
                type="checkbox"
                className="m-2"
                checked={hasChat}
                onInput={(e) => changeHandler(e)}
                id="hasChat"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">Is Network Enabled</label>
              <input
                type="checkbox"
                className="m-2"
                checked={isNetworkEnabled}
                onInput={(e) => changeHandler(e)}
                id="isNetworkEnabled"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Chat Code</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={chatCode}
                onInput={(e) => changeHandler(e)}
                id="chatCode"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">
                Has PR Number Enabled
              </label>
              <input
                type="checkbox"
                id="prNumberEnabled"
                className="m-2"
                checked={prNumberEnabled}
                onInput={(e) => changeHandler(e)}
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Video Chat Commission
            </label>
            <div className="col-md-12">
              <input
                type="text"
                name="videoChatCommission"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={videoChatCommission}
                onInput={(e) => changeHandler(e)}
                id="commission"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Audio Chat Commission
            </label>
            <div className="col-md-12">
              <input
                type="text"
                name="audioChatCommission"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={audioChatCommission}
                onInput={(e) => changeHandler(e)}
                id="commission"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Text Chat Commission</label>
            <div className="col-md-12">
              <input
                type="text"
                name="textChatCommission"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={textChatCommission}
                onInput={(e) => changeHandler(e)}
                id="commission"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <div className="col-md-12">
              <label className="label-text-siteMob">
                Is Parent Organization
              </label>
              <input
                type="checkbox"
                id="isParent"
                className="m-2"
                checked={isParent}
                onInput={(e) => changeHandler(e)}
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Parent Organization Name
            </label>
            <div className="col-md-12">
              <select
                className="hspInfofieldinput Infoinputwidthdoctr"
                id="parentSiteId"
                value={parentSiteId}
                onInput={(e) => changeHandler(e)}
              >
                <option value="">Select Organization</option>
                {siteList.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.siteName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Admin Email Id</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={adminEmailId}
                onInput={(e) => changeHandler(e)}
                id="adminEmailId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Admin Contact No</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={adminContactNo}
                onInput={(e) => changeHandler(e)}
                id="adminContactNo"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              In-Person Appointment Time Interval
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                defaultValue={inPersonAppointmentTimeInterval}
                onInput={(e) => changeHandler(e)}
                id="inPersonAppointmentTimeInterval"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Video Chat Appointment Time Interval
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                defaultValue={videoAppointmentTimeInterval}
                onInput={(e) => changeHandler(e)}
                id="videoAppointmentTimeInterval"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Audio Chat Appointment Time Interval
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                defaultValue={callADoctorTimeInterval}
                onInput={(e) => changeHandler(e)}
                id="callADoctorTimeInterval"
              ></input>
            </div>
          </div>
        </div>
        <div className="row col-md-12 m-0">
          <h4 className="row-margin col-md-12 hspInfoSubhead-site">
            Practice Management Settings
          </h4>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Pulse Name</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={pulseNameData}
                onInput={(e) => changeHandler(e)}
                id="pulseNameData"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Pulse Site Url</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={pulseSiteUrl}
                onInput={(e) => changeHandler(e)}
                id="pulseSiteUrl"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Pulse Session Time Out URL
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={pulseSessionTimeOutUrl}
                onInput={(e) => changeHandler(e)}
                id="pulseSessionTimeOutUrl"
              ></input>
            </div>
          </div>
        </div>
        <div className="row col-md-12 m-0">
          <h4 className="row-margin col-md-12 hspInfoSubhead-site">
            Sms and Email Settings
          </h4>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Sms Sender Id</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={smsSenderId}
                onInput={(e) => changeHandler(e)}
                id="smsSenderId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Sms Gateway Entity Id
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={smsGatewayEntityId}
                onInput={(e) => changeHandler(e)}
                id="smsGatewayEntityId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Email Host</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={emailHost}
                onInput={(e) => changeHandler(e)}
                id="emailHost"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Email User Id</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={emailUserId}
                onInput={(e) => changeHandler(e)}
                id="emailUserId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Email Password</label>
            <div className="col-md-12">
              <input
                type="password"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={emailPassword}
                onInput={(e) => changeHandler(e)}
                id="emailPassword"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Email Port</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={emailPort}
                onInput={(e) => changeHandler(e)}
                id="emailPort"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Total Transactional Sms Count
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={totalTransactionalSmsCount}
                onKeyUp={(e) => isNumber(e)}
                onInput={(e) => changeHandler(e)}
                id="totalTransactionalSmsCount"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Total Promotional Sms Count
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={totalPromotionalSmsCount}
                onKeyUp={(e) => isNumber(e)}
                onInput={(e) => changeHandler(e)}
                id="totalPromotionalSmsCount"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Available Transactional Sms Count
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={availTransactionalSmsCount}
                onKeyUp={(e) => isNumber(e)}
                onInput={(e) => changeHandler(e)}
                id="availTransactionalSmsCount"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Avail Promotional Sms Count
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={availPromotionalSmsCount}
                onKeyUp={(e) => isNumber(e)}
                onInput={(e) => changeHandler(e)}
                id="availPromotionalSmsCount"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Transactional Sms Valid From
            </label>
            <div className="col-md-12 react-date-dctr-width site-inputfield-width">
              <DatePicker
                id="transactionalSmsValidFrom"
                name="transactionalSmsValidFrom"
                placeholderText="Transactional Sms Valid From"
                // maxDate={new Date()}
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                dropdownMode="scroll"
                peekNextMonth
                disabledKeyboardNavigation
                onSelect={(date) =>
                  dateChangeHandler(date, "transactionalSmsValidFrom")
                }
                value={transactionalSmsValidFrom}
                dateFormat="dd/MM/yyyy"
                calendarClassName="react-date-picker"
                autoComplete="off"
                tabIndex="3"
                onKeyDown={(e) =>
                  disableDateField(e, "transactionalSmsValidFrom")
                }
                onFocus={(event) => event.target.select()}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Transactional Sms Valid To
            </label>
            <div className="col-md-12 react-date-dctr-width site-inputfield-width">
              <DatePicker
                id="transactionalSmsValidTo"
                name="transactionalSmsValidTo"
                placeholderText="Transactional Sms Valid To"
                //minDate={new Date()}
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                dropdownMode="scroll"
                peekNextMonth
                disabledKeyboardNavigation
                onSelect={(date) =>
                  dateChangeHandler(date, "transactionalSmsValidTo")
                }
                value={transactionalSmsValidTo}
                dateFormat="dd/MM/yyyy"
                calendarClassName="react-date-picker"
                autoComplete="off"
                tabIndex="3"
                onKeyDown={(e) =>
                  disableDateField(e, "transactionalSmsValidTo")
                }
                onFocus={(event) => event.target.select()}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Promotional Sms Valid From
            </label>
            <div className="col-md-12 react-date-dctr-width site-inputfield-width">
              <DatePicker
                id="promotionalSmsValidFrom"
                name="promotionalSmsValidFrom"
                placeholderText="Promotional Sms Valid From"
                // maxDate={new Date()}
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                dropdownMode="scroll"
                peekNextMonth
                disabledKeyboardNavigation
                onSelect={(date) =>
                  dateChangeHandler(date, "promotionalSmsValidFrom")
                }
                value={promotionalSmsValidFrom}
                dateFormat="dd/MM/yyyy"
                calendarClassName="react-date-picker"
                autoComplete="off"
                tabIndex="3"
                onKeyDown={(e) =>
                  disableDateField(e, "promotionalSmsValidFrom")
                }
                onFocus={(event) => event.target.select()}
              />
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Promotional Sms Valid To
            </label>
            <div className="col-md-12 react-date-dctr-width site-inputfield-width">
              <DatePicker
                id="promotionalSmsValidTo"
                name="promotionalSmsValidTo"
                placeholderText="Promotional Sms Valid To"
                // maxDate={new Date()}
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                dropdownMode="scroll"
                peekNextMonth
                disabledKeyboardNavigation
                onSelect={(date) =>
                  dateChangeHandler(date, "promotionalSmsValidTo")
                }
                value={promotionalSmsValidTo}
                dateFormat="dd/MM/yyyy"
                calendarClassName="react-date-picker"
                autoComplete="off"
                tabIndex="3"
                onKeyDown={(e) => disableDateField(e, "promotionalSmsValidTo")}
                onFocus={(event) => event.target.select()}
              />
            </div>
          </div>
        </div>
        <div className="row col-md-12 m-0">
          <h4 className="row-margin col-md-12 hspInfoSubhead-site">
            Group Admin and Hospitals
          </h4>
          <h5 className="row-margin col-md-12 hspInfoSubhead-site">
            Admin Details
          </h5>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">User Title</label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={userTitle}
                onInput={(e) => changeHandler(e)}
                id="userTitle"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Display Name <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={displayName}
                onInput={(e) => changeHandler(e)}
                id="displayName"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Mobile Number <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <input
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={mobileNumber}
                onInput={(e) => changeHandler(e)}
                id="mobileNumber"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">
              Email ID <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <input
                type="email"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={groupEmailId}
                onInput={(e) => changeHandler(e)}
                id="groupEmailId"
              ></input>
            </div>
          </div>
          <div className="row-margin hspinfo-contentdiv">
            {/* <label className="col-md-12 label-text">
                Password
              </label>
              <div className="col-md-12">
                <input
                  type="password"
                  className="hspInfofieldinput Infoinputwidthdoctr"
                  value={groupPassword}
                  onInput={(e) => changeHandler(e)}
                  id="groupPassword"
                ></input>
              </div> */}
            <span
              className="smssetng-svebtn"
              onClick={() => {
                $("#changePassPopup").show();
              }}
            >
              Change Password
            </span>
          </div>
          {/* {props.doctorId ? (
                    <div className="hspinfo-contentdiv">
                      <span
                        className="smssetng-svebtn"
                        onClick={() => {
                          $("#changePassPopup").show();
                        }}
                      >
                        Change Password
                      </span>
                    </div>
                  ) : (
                    ""
                  )} */}
          <div className="row-margin hspinfo-contentdiv">
            <label className="col-md-12 label-text">Status</label>
            <div className="col-md-12">
              <select
                type="text"
                className="hspInfofieldinput Infoinputwidthdoctr"
                value={enabled}
                onChange={(e) => changeHandler(e)}
                id="enabled"
              >
                <option value="true">Enabled</option>
                <option value="false">Disabled</option>
              </select>
            </div>
          </div>
          <h5 className="row-margin col-md-12 hspInfoSubhead-site">
            Group Of Hospitals
          </h5>
          <div className="row-margin col-md-12 hspinfo-contentdiv p-0">
            {/* <div className="hspinfo-contentdiv"> */}
            <label className="col-md-12 label-text">Hospital Name</label>
            <div className="row sitegrphsp-input">
              {/* <div className="col-md-11"> */}
              <HospitalAutoComplete
                onItemChange={handleHospitalAutoFill}
                setSearch={handleHospitalSearch}
                tempHospitalData={tempHospitalData}
                // className="hspInfofieldinput Infoinputwidthdoctr"
              />
              {/* </div> */}
              <div className="col-md-1 grpsiteicon-addmob">
                <a onClick={() => handleAddHospital()}>
                  <img src={IcoAdd} width="25"></img>
                </a>
              </div>
              {/* </div> */}
            </div>
          </div>
          {hospitalData.map((hospital) => (
            <div key={hospital.hospitalId} className="hspinfo-contentdiv">
              <label></label>
              <div className="row sitegrphsp-input">
                {/* <div className="col-md-10"> */}
                <input
                  type="text"
                  readOnly
                  value={hospital.hospitalName}
                  id={hospital.hospitalId}
                  className="hspInfofieldinput Infoinputwidthdoctr"
                ></input>
                {/* </div> */}
                <div className="col-md-1 grpsiteicon-addmob">
                  <a onClick={() => handleCancelHospital(hospital.hospitalId)}>
                    <img src={IcoCancel} width="25"></img>
                  </a>
                </div>
              </div>
            </div>
          ))}
          <h5 className="row-margin col-md-12 hspInfoSubhead-site">
            Expert Doctors
          </h5>
          <div className="row-margin hspinfo-contentdiv p-0 col-md-12">
            {/* <div className="hspinfo-contentdiv"> */}
            <label className="col-md-12 label-text">Expert Doctors Name</label>
            <div className="row sitegrphsp-input">
              {/* <div className="col-md-11"> */}
              <DoctorAutoComplete
                onItemChange={handleDoctorAutoFill}
                setSearch={handleDoctorSearch}
                tempHospitalData={tempDoctorData}
                doctorIds={hospitalIdsList}
                key={hospitalIdsList}
              />
              {/* </div> */}
              <div className="col-md-1 grpsiteicon-addmob">
                <a onClick={() => handleAddDoctor()}>
                  <img src={IcoAdd} width="25"></img>
                </a>
              </div>
              {/* </div> */}
            </div>
          </div>
          <div className="col-md-12">
            <div className="row mx-0">
              {doctorDataList.map((doctor) => (
                <div key={doctor.doctorId} className="col-md-3">
                  <div className="row ">
                    <div className="row sitegrphsp-input col-md-11">
                      {/* <div className="col-md-10"> */}
                      <input
                        type="text"
                        readOnly
                        value={doctor.doctorName}
                        id={doctor.doctorId}
                        className="hspInfofieldinput Infoinputwidthdoctr"
                      ></input>
                    </div>
                    {/* </div> */}
                    <div className="col-md-1 grpsiteicon-addmob">
                      <a onClick={() => handleCancelDoctor(doctor.doctorId)}>
                        <img src={IcoCancel} width="25"></img>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <h5 className="row-margin col-md-12 hspInfoSubhead-site">
            Home Page Settings
          </h5>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Google Analytics Script{" "}
              <span className="hspifoMantory">
                (Must contain Google Analytics ID, Clarity ID Eg:
                GA-76eeG90,Cl-334akkL)
              </span>
            </label>
            <div className="col-md-12">
              <textarea
                value={googleSiteAnalytics}
                onInput={(e) => changeHandler(e)}
                id="googleSiteAnalytics"
                placeholder="Must contain Google Analytics ID, Clarity ID"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Home Page
            </label>
            <div className="col-md-12">
              <textarea
                value={innerHtml}
                onInput={(e) => changeHandler(e)}
                id="innerHtml"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Hospital Admin Dashboard
              {/* <span className="hspifoMantory">*</span> */}
            </label>
            <div className="col-md-12">
              <textarea
                value={dashboardHtml}
                onInput={(e) => changeHandler(e)}
                id="dashboardHtml"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Registration Terms
            </label>
            <div className="col-md-12">
              <textarea
                value={registraionTerms}
                onInput={(e) => changeHandler(e)}
                id="registraionTerms"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Registration Terms
            </label>
            <div className="col-md-12">
              <textarea
                value={pulseRegistraionTerms}
                onInput={(e) => changeHandler(e)}
                id="pulseRegistraionTerms"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Email Consult Terms
            </label>
            <div className="col-md-12">
              <textarea
                value={emailConsultTerms}
                onInput={(e) => changeHandler(e)}
                id="emailConsultTerms"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Video Chat Terms
            </label>
            <div className="col-md-12">
              <textarea
                value={videoChatTerms}
                onInput={(e) => changeHandler(e)}
                id="videoChatTerms"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              In Person Terms
            </label>
            <div className="col-md-12">
              <textarea
                value={bookAppointmentTerms}
                onInput={(e) => changeHandler(e)}
                id="bookAppointmentTerms"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Welcome Text
            </label>
            <div className="col-md-12">
              <textarea
                value={welcomeText}
                onInput={(e) => changeHandler(e)}
                id="welcomeText"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Registration Email Text
            </label>
            <div className="col-md-12">
              <textarea
                value={registrationMailText}
                onInput={(e) => changeHandler(e)}
                id="registrationMailText"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Seo Description
            </label>
            <div className="col-md-12">
              <textarea
                value={seoDescription}
                onInput={(e) => changeHandler(e)}
                id="seoDescription"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Patient App Privacy Policy
            </label>
            <div className="col-md-12">
              <textarea
                value={privacyPolicy}
                onInput={(e) => changeHandler(e)}
                id="privacyPolicy"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Patient App Terms And Condition
            </label>
            <div className="col-md-12">
              <textarea
                value={termsAndCondition}
                onInput={(e) => changeHandler(e)}
                id="termsAndCondition"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Doctor App Privacy Policy
            </label>
            <div className="col-md-12">
              <textarea
                value={doctorAppPrivacyPolicy}
                onInput={(e) => changeHandler(e)}
                id="doctorAppPrivacyPolicy"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Doctor App Terms And Condition
            </label>
            <div className="col-md-12">
              <textarea
                value={doctorAppTermsAndCondition}
                onInput={(e) => changeHandler(e)}
                id="doctorAppTermsAndCondition"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Seo Title/Site Title <span className="hspifoMantory">*</span>
            </label>
            <div className="col-md-12">
              <textarea
                value={seoTitle}
                onInput={(e) => changeHandler(e)}
                id="seoTitle"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Seo Keywords
            </label>
            <div className="col-md-12">
              <textarea
                value={seoKeywords}
                onInput={(e) => changeHandler(e)}
                id="seoKeywords"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">Slug</label>
            <div className="col-md-12">
              <textarea
                value={slug}
                onInput={(e) => changeHandler(e)}
                id="slug"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Slug
            </label>
            <div className="col-md-12">
              <textarea
                value={pulseSlug}
                onInput={(e) => changeHandler(e)}
                id="pulseSlug"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Pulse Title
            </label>
            <div className="col-md-12">
              <textarea
                value={pulseTitle}
                onInput={(e) => changeHandler(e)}
                id="pulseTitle"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Address
            </label>
            <div className="col-md-12">
              <textarea
                value={address}
                onInput={(e) => changeHandler(e)}
                id="address"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Hospital Working Time
            </label>
            <div className="col-md-12">
              <textarea
                value={hospitalWorkingTime}
                onInput={(e) => changeHandler(e)}
                id="hospitalWorkingTime"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Patient Dash Board
            </label>
            <div className="col-md-12">
              <textarea
                value={patientDashBoard}
                onInput={(e) => changeHandler(e)}
                id="patientDashBoard"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
          <div className="siteset-textareafield">
            <label className="col-md-12 label-sitesethsptextarea">
              Google AdSense Id(s) (Client-Id,Slot-Id)
            </label>
            <div className="col-md-12">
              <textarea
                value={advertisementScript}
                onInput={(e) => changeHandler(e)}
                placeholder="xxxx,xxxx"
                id="advertisementScript"
                style={{
                  minHeight: 80,
                  maxHeight: 90,
                }}
                className="textarea-hspservice"
              ></textarea>
            </div>
          </div>
        </div>
        <div className="sitesetngbtndiv text-right">
          <a
            className="sitesetng-cancelbtn mx-1"
            onClick={() => changeMode("list", navigation, 0, "Add/Edit Site")}
          >
            Cancel
          </a>
          <a
            className="smssetng-svebtn smssetng-svebtn-padd"
            onClick={(e) => foldersinS3bucket(e)}
          >
            Save
          </a>
        </div>
      </div>
      <div className="modalinput_show" id="changePassPopup">
        <div className="modalinput_inner">
          <div className="close_modalinput">
            <img
              src={Close}
              onClick={() => {
                $("#changePassPopup").hide();
              }}
            />
          </div>
          <div className="modal_innerform">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => setnewPassword(e.target.value)}
            />
          </div>
          <div className="modal_informationfooter">
            <input
              type="button"
              className="smssetng-svebtn"
              value="save"
              onClick={() => changePass()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
